export const $AIPromptConfigCreate = {
	description: `Model for creating new AI prompt configurations.`,
	properties: {
		version: {
	type: 'string',
	description: `Version identifier (simple, standard, enhanced)`,
	isRequired: true,
	maxLength: 50,
},
		model: {
	type: 'string',
	description: `Model identifier or raw provider model string`,
	isRequired: true,
	maxLength: 255,
},
		agent_key: {
	type: 'any-of',
	description: `Optional agent identifier (e.g., alex_v1)`,
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		variant: {
	type: 'string',
	description: `Internal free-form variant label for prompt slot grouping`,
	default: 'default',
	maxLength: 255,
},
		lifecycle_status: {
	type: 'string',
	description: `Prompt lifecycle state: draft, live, or retired`,
	default: 'draft',
	maxLength: 20,
},
		revision_number: {
	type: 'number',
	description: `Monotonic revision number within (agent_key, variant, model) slot`,
	default: 1,
	minimum: 1,
},
		source_config_id: {
	type: 'any-of',
	description: `Optional source prompt revision id when draft was created from existing`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		promoted_from_config_id: {
	type: 'any-of',
	description: `Optional previously-live revision id when this revision was promoted`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		promoted_at: {
	type: 'any-of',
	description: `Timestamp when this revision was promoted to live`,
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		change_note: {
	type: 'any-of',
	description: `Optional operator note describing the revision intent`,
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		max_tokens: {
	type: 'number',
	description: `Maximum tokens to generate`,
	default: 250,
	maximum: 64000,
	minimum: 50,
},
		temperature: {
	type: 'number',
	description: `Sampling temperature`,
	default: 0.5,
	maximum: 2,
	minimum: 0,
},
		top_p: {
	type: 'number',
	description: `Nucleus sampling parameter (1.0 uses full probability mass)`,
	default: 1,
	maximum: 1,
	minimum: 0,
},
		top_k: {
	type: 'any-of',
	description: `Optional top-k sampling limit; null defers to provider default`,
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		frequency_penalty: {
	type: 'number',
	description: `Penalty applied to repeated tokens`,
	default: 0,
	maximum: 2,
	minimum: -2,
},
		presence_penalty: {
	type: 'number',
	description: `Penalty encouraging topic diversity`,
	default: 0,
	maximum: 2,
	minimum: -2,
},
		stop_sequences: {
	type: 'array',
	contains: {
	type: 'string',
},
},
		system_prompt: {
	type: 'string',
	description: `System prompt that defines the AI behavior and output format`,
	isRequired: true,
},
		output_schema_json: {
	type: 'any-of',
	description: `Optional JSON schema for validating structured model output`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		batch_runner_spec: {
	type: 'any-of',
	description: `Optional configuration for post-batch (chord callback) processors. When set, the config may be selectable in schedule UIs and used to build the payload and merge strategy for generic post-batch LLM runs.`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		is_active: {
	type: 'boolean',
	description: `Whether this configuration is currently active`,
	default: true,
},
	},
} as const;

export const $AIPromptConfigPublic = {
	description: `Public model for AI prompt configurations.`,
	properties: {
		version: {
	type: 'string',
	description: `Version identifier (simple, standard, enhanced)`,
	isRequired: true,
	maxLength: 50,
},
		model: {
	type: 'string',
	description: `Model identifier or raw provider model string`,
	isRequired: true,
	maxLength: 255,
},
		agent_key: {
	type: 'any-of',
	description: `Optional agent identifier (e.g., alex_v1)`,
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		variant: {
	type: 'string',
	description: `Internal free-form variant label for prompt slot grouping`,
	default: 'default',
	maxLength: 255,
},
		lifecycle_status: {
	type: 'string',
	description: `Prompt lifecycle state: draft, live, or retired`,
	default: 'draft',
	maxLength: 20,
},
		revision_number: {
	type: 'number',
	description: `Monotonic revision number within (agent_key, variant, model) slot`,
	default: 1,
	minimum: 1,
},
		source_config_id: {
	type: 'any-of',
	description: `Optional source prompt revision id when draft was created from existing`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		promoted_from_config_id: {
	type: 'any-of',
	description: `Optional previously-live revision id when this revision was promoted`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		promoted_at: {
	type: 'any-of',
	description: `Timestamp when this revision was promoted to live`,
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		change_note: {
	type: 'any-of',
	description: `Optional operator note describing the revision intent`,
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		max_tokens: {
	type: 'number',
	description: `Maximum tokens to generate`,
	default: 250,
	maximum: 64000,
	minimum: 50,
},
		temperature: {
	type: 'number',
	description: `Sampling temperature`,
	default: 0.5,
	maximum: 2,
	minimum: 0,
},
		top_p: {
	type: 'number',
	description: `Nucleus sampling parameter (1.0 uses full probability mass)`,
	default: 1,
	maximum: 1,
	minimum: 0,
},
		top_k: {
	type: 'any-of',
	description: `Optional top-k sampling limit; null defers to provider default`,
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		frequency_penalty: {
	type: 'number',
	description: `Penalty applied to repeated tokens`,
	default: 0,
	maximum: 2,
	minimum: -2,
},
		presence_penalty: {
	type: 'number',
	description: `Penalty encouraging topic diversity`,
	default: 0,
	maximum: 2,
	minimum: -2,
},
		stop_sequences: {
	type: 'array',
	contains: {
	type: 'string',
},
},
		system_prompt: {
	type: 'string',
	description: `System prompt that defines the AI behavior and output format`,
	isRequired: true,
},
		output_schema_json: {
	type: 'any-of',
	description: `Optional JSON schema for validating structured model output`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		batch_runner_spec: {
	type: 'any-of',
	description: `Optional configuration for post-batch (chord callback) processors. When set, the config may be selectable in schedule UIs and used to build the payload and merge strategy for generic post-batch LLM runs.`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		is_active: {
	type: 'boolean',
	description: `Whether this configuration is currently active`,
	default: true,
},
		id: {
	type: 'number',
	isRequired: true,
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updated_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
	},
} as const;

export const $AIPromptConfigUpdate = {
	description: `Model for updating AI prompt configurations.`,
	properties: {
		model: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		variant: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		lifecycle_status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		revision_number: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		source_config_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		promoted_from_config_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		promoted_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		change_note: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		max_tokens: {
	type: 'any-of',
	contains: [{
	type: 'number',
	maximum: 64000,
	minimum: 50,
}, {
	type: 'null',
}],
},
		temperature: {
	type: 'any-of',
	contains: [{
	type: 'number',
	maximum: 2,
	minimum: 0,
}, {
	type: 'null',
}],
},
		top_p: {
	type: 'any-of',
	contains: [{
	type: 'number',
	maximum: 1,
	minimum: 0,
}, {
	type: 'null',
}],
},
		top_k: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		frequency_penalty: {
	type: 'any-of',
	contains: [{
	type: 'number',
	maximum: 2,
	minimum: -2,
}, {
	type: 'null',
}],
},
		presence_penalty: {
	type: 'any-of',
	contains: [{
	type: 'number',
	maximum: 2,
	minimum: -2,
}, {
	type: 'null',
}],
},
		stop_sequences: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'string',
},
}, {
	type: 'null',
}],
},
		system_prompt: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		output_schema_json: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		is_active: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $AIPromptConfigsPublic = {
	description: `Public model for list of AI prompt configurations.`,
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'AIPromptConfigPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $AIPromptDraftUpdate = {
	description: `Update a draft revision.`,
	properties: {
		system_prompt: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		version: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		max_tokens: {
	type: 'any-of',
	contains: [{
	type: 'number',
	maximum: 64000,
	minimum: 50,
}, {
	type: 'null',
}],
},
		temperature: {
	type: 'any-of',
	contains: [{
	type: 'number',
	maximum: 2,
	minimum: 0,
}, {
	type: 'null',
}],
},
		top_p: {
	type: 'any-of',
	contains: [{
	type: 'number',
	maximum: 1,
	minimum: 0,
}, {
	type: 'null',
}],
},
		top_k: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		frequency_penalty: {
	type: 'any-of',
	contains: [{
	type: 'number',
	maximum: 2,
	minimum: -2,
}, {
	type: 'null',
}],
},
		presence_penalty: {
	type: 'any-of',
	contains: [{
	type: 'number',
	maximum: 2,
	minimum: -2,
}, {
	type: 'null',
}],
},
		stop_sequences: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'string',
},
}, {
	type: 'null',
}],
},
		output_schema_json: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		batch_runner_spec: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		change_note: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
	},
} as const;

export const $AIPromptRevisionCreate = {
	description: `Create a new draft prompt revision (brand-new or from existing source).`,
	properties: {
		agent_key: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		variant: {
	type: 'string',
	default: 'default',
	maxLength: 255,
},
		model: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		system_prompt: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		version: {
	type: 'string',
	default: 'v1',
	maxLength: 50,
},
		max_tokens: {
	type: 'number',
	default: 250,
	maximum: 64000,
	minimum: 50,
},
		temperature: {
	type: 'number',
	default: 0.5,
	maximum: 2,
	minimum: 0,
},
		top_p: {
	type: 'number',
	default: 1,
	maximum: 1,
	minimum: 0,
},
		top_k: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		frequency_penalty: {
	type: 'number',
	default: 0,
	maximum: 2,
	minimum: -2,
},
		presence_penalty: {
	type: 'number',
	default: 0,
	maximum: 2,
	minimum: -2,
},
		stop_sequences: {
	type: 'array',
	contains: {
	type: 'string',
},
},
		output_schema_json: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		batch_runner_spec: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		source_config_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		change_note: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
	},
} as const;

export const $AIPromptSlotPublic = {
	description: `Grouped prompt slot summary with latest draft + current live revisions.`,
	properties: {
		agent_key: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		variant: {
	type: 'string',
	isRequired: true,
},
		model: {
	type: 'string',
	isRequired: true,
},
		live: {
	type: 'any-of',
	contains: [{
	type: 'AIPromptConfigPublic',
}, {
	type: 'null',
}],
},
		latest_draft: {
	type: 'any-of',
	contains: [{
	type: 'AIPromptConfigPublic',
}, {
	type: 'null',
}],
},
		total_revisions: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $AIPromptSlotsPublic = {
	description: `Public model for list of grouped prompt slots.`,
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'AIPromptSlotPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $AccessRequestData = {
	properties: {
		name: {
	type: 'string',
	isRequired: true,
},
		email: {
	type: 'string',
	isRequired: true,
	format: 'email',
},
	},
} as const;

export const $ActiveBrandBody = {
	properties: {
		activeBrand: {
	type: 'Enum',
	enum: ['wysehub','aiclaims',],
	isRequired: true,
},
	},
} as const;

export const $AgentRunPublic = {
	properties: {
		agentName: {
	type: 'string',
	isRequired: true,
	maxLength: 50,
},
		runType: {
	type: 'string',
	isRequired: true,
	maxLength: 50,
},
		status: {
	type: 'string',
	description: `pending, in_progress, success, failure`,
	default: 'pending',
	maxLength: 20,
},
		referralId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		claimId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		userId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		taskId: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		model: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		version: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 50,
}, {
	type: 'null',
}],
},
		cacheHit: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		cacheStatus: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 16,
}, {
	type: 'null',
}],
},
		cacheCreationInputTokens: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		cacheReadInputTokens: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		cacheablePrefixSize: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		cacheCheckpointsCount: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		durationSeconds: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		callLengthSeconds: {
	type: 'any-of',
	description: `Recorded call audio length in seconds (for STT cost)`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		inputTokens: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		outputTokens: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		totalTokens: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		totalApiCost: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		startedAt: {
	type: 'string',
	format: 'date-time',
},
		completedAt: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		errorMessage: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		metadata: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		tenantId: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		workflowId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		promptSource: {
	type: 'any-of',
	description: `Prompt storage source (postgres)`,
	contains: [{
	type: 'string',
	maxLength: 20,
}, {
	type: 'null',
}],
},
		promptAppSlug: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		promptVariantSlug: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		promptEnvironment: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 50,
}, {
	type: 'null',
}],
},
		promptVersionNumber: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		promptVersionId: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		otelTraceId: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		otelSpanId: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		evaluationMode: {
	type: 'boolean',
	default: false,
},
		evaluationRunId: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		comparisonGroupId: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updated_datetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;

export const $AgentRunSummary = {
	properties: {
		total: {
	type: 'number',
	isRequired: true,
},
		breakdown: {
	type: 'array',
	contains: {
		type: 'AgentRunSummaryItem',
	},
	isRequired: true,
},
	},
} as const;

export const $AgentRunSummaryItem = {
	properties: {
		agent_name: {
	type: 'string',
	isRequired: true,
},
		status: {
	type: 'string',
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $AgentRunsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'AgentRunPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $AiClaimsDashboardSummaryPublic = {
	properties: {
		workflowsConfigured: {
	type: 'number',
	isRequired: true,
},
		workflowsActive: {
	type: 'number',
	isRequired: true,
},
		runsTotal: {
	type: 'number',
	isRequired: true,
},
		runsFailed: {
	type: 'number',
	isRequired: true,
},
		totalCost: {
	type: 'number',
	isRequired: true,
},
		successRatePct: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $AiClaimsReferralIntakeAcceptedItem = {
	properties: {
		intakeId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		externalReferenceKey: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		status: {
	type: 'string',
	isRequired: true,
},
		idempotentReplay: {
	type: 'boolean',
	default: false,
},
		projectionReferralId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		summaryTaskId: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $AiClaimsReferralIntakeItem = {
	properties: {
		externalReferenceKey: {
	type: 'any-of',
	description: `Your system reference for this claim (e.g. claim number, policy reference, case ID).  Used for response correlation, idempotency, and stored as the referral source reference.`,
	contains: [{
	type: 'string',
	maxLength: 128,
}, {
	type: 'null',
}],
},
		workflowId: {
	type: 'number',
	description: `ID of the WorkflowDefinition to run against this claim.  The referenced workflow must exist in the workflow_definition table.`,
	isRequired: true,
},
		claimContext: {
	type: 'any-of',
	description: `Structured claim details consumed by the AI agent workflow.  Documented fields are optional and validated.  Additional partner-specific keys are accepted and stored verbatim for downstream workflows and report templates.  accidentCircs is usually the most important field for meaningful AI output.`,
	contains: [{
	type: 'ReportDataClaimContext',
}, {
	type: 'null',
}],
},
		notes: {
	type: 'any-of',
	description: `Free-text notes to attach to the projected referral.  Included verbatim in AI context alongside claimContext.  Maximum 50 notes per item.`,
	contains: [{
	type: 'array',
	contains: {
		type: 'ReportDataNoteItem',
	},
}, {
	type: 'null',
}],
},
	},
} as const;

export const $AiClaimsReferralIntakeRequest = {
	properties: {
		partnerId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		partnerRequestId: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		forceRerun: {
	type: 'boolean',
	default: false,
},
		items: {
	type: 'array',
	contains: {
		type: 'AiClaimsReferralIntakeItem',
	},
	isRequired: true,
},
	},
} as const;

export const $AiClaimsReferralIntakeResponse = {
	properties: {
		operationId: {
	type: 'number',
	isRequired: true,
},
		operationTaskId: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		partnerId: {
	type: 'number',
	isRequired: true,
},
		partnerRequestId: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		serverRequestId: {
	type: 'string',
	isRequired: true,
},
		acceptedCount: {
	type: 'number',
	isRequired: true,
},
		duplicateCount: {
	type: 'number',
	isRequired: true,
},
		invalidCount: {
	type: 'number',
	isRequired: true,
},
		status: {
	type: 'string',
	isRequired: true,
},
		items: {
	type: 'array',
	contains: {
		type: 'AiClaimsReferralIntakeAcceptedItem',
	},
	isRequired: true,
},
	},
} as const;

export const $AnnieCreate = {
	properties: {
		accident_circs: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		recordingUrl: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Annie_Result = {
	properties: {
		createdDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		circs_grade_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		accident_circs: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		claim_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		fault_probability: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		nonfault_probability: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		split_probability: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		trigger: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		probability: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		adjustedliabscore: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ApiKeyIssueRequest = {
	properties: {
		partnerId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		scopes: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		expiresDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ApiKeyMetadataPublic = {
	properties: {
		id: {
	type: 'number',
	isRequired: true,
},
		userId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		partnerId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		createdByUserId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		scopes: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		expiresDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		lastUsedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		revokedReason: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		createdDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ApiKeyMetadataUpdateRequest = {
	properties: {
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		scopes: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		expiresDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		revokedReason: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ApiKeysMetadataPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'ApiKeyMetadataPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $AppSettingCreate = {
	description: `Model for creating new application settings.`,
	properties: {
		key: {
	type: 'string',
	description: `Setting key (e.g., RATELIMITER_MAX_ATTEMPTS)`,
	isRequired: true,
	maxLength: 255,
},
		value: {
	type: 'string',
	description: `Setting value as string (type-safe via value_type)`,
	isRequired: true,
},
		value_type: {
	type: 'string',
	description: `Value type: string, int, bool, float, json`,
	default: 'string',
	maxLength: 50,
},
		category: {
	type: 'string',
	description: `Setting category: rate_limiting, ai_models, email, storage, logging, features, etc.`,
	isRequired: true,
	maxLength: 100,
},
		environment: {
	type: 'string',
	description: `Target environment: local, staging, production, or all`,
	isRequired: true,
	maxLength: 50,
},
		is_active: {
	type: 'boolean',
	description: `Whether this setting is active`,
	default: true,
},
		description: {
	type: 'any-of',
	description: `Human-readable description of the setting`,
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
	},
} as const;

export const $AppSettingPublic = {
	description: `Public model for application settings.`,
	properties: {
		key: {
	type: 'string',
	description: `Setting key (e.g., RATELIMITER_MAX_ATTEMPTS)`,
	isRequired: true,
	maxLength: 255,
},
		value: {
	type: 'string',
	description: `Setting value as string (type-safe via value_type)`,
	isRequired: true,
},
		value_type: {
	type: 'string',
	description: `Value type: string, int, bool, float, json`,
	default: 'string',
	maxLength: 50,
},
		category: {
	type: 'string',
	description: `Setting category: rate_limiting, ai_models, email, storage, logging, features, etc.`,
	isRequired: true,
	maxLength: 100,
},
		environment: {
	type: 'string',
	description: `Target environment: local, staging, production, or all`,
	isRequired: true,
	maxLength: 50,
},
		is_active: {
	type: 'boolean',
	description: `Whether this setting is active`,
	default: true,
},
		description: {
	type: 'any-of',
	description: `Human-readable description of the setting`,
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updated_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
	},
} as const;

export const $AppSettingUpdate = {
	description: `Model for updating application settings.`,
	properties: {
		value: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		value_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		category: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		environment: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		is_active: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $AppSettingsPublic = {
	description: `Public model for list of application settings.`,
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'AppSettingPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $AuthoritiesPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'AuthorityPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $AuthorityCreate = {
	properties: {
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $AuthorityPublic = {
	properties: {
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $AuthorityUpdate = {
	properties: {
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $BatchPostprocessorOption = {
	description: `Lightweight option shape for schedule dropdowns.`,
	properties: {
		agent_key: {
	type: 'string',
	isRequired: true,
},
		display_name: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $BatchPostprocessorOptions = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'BatchPostprocessorOption',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $Body_aiclaims_audit_batch_endpoint = {
	properties: {
		quote_pdf: {
	type: 'string',
	isRequired: true,
},
		call_audio: {
	type: 'array',
	contains: {
	type: 'string',
},
	isRequired: true,
},
		client_reference: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		call_agent_name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		mode: {
	type: 'string',
	default: 'queue',
},
	},
} as const;

export const $Body_aiclaims_submit_call_analysis_job = {
	properties: {
		workflowId: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $Body_aiclaims_upload_call_analysis = {
	properties: {
		file: {
	type: 'string',
	isRequired: true,
},
		callReference: {
	type: 'string',
	isRequired: true,
},
		callDate: {
	type: 'string',
	isRequired: true,
	format: 'date',
},
		workflowId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		partnerId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Body_calls_incoming_call = {
	properties: {
		From: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $Body_edge_import_upload_edge_csv = {
	properties: {
		partner_id: {
	type: 'number',
	isRequired: true,
},
		file: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $Body_login_login_access_token = {
	properties: {
		grant_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
	pattern: '^password$',
}, {
	type: 'null',
}],
},
		username: {
	type: 'string',
	isRequired: true,
},
		password: {
	type: 'string',
	isRequired: true,
	format: 'password',
},
		scope: {
	type: 'string',
	default: '',
},
		client_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_secret: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Body_referrals_create_bulk_summary_operation = {
	properties: {
		allocation_statuses: {
	type: 'array',
	contains: {
	type: 'string',
},
	isRequired: true,
},
		model: {
	type: 'string',
	description: `AI model key (sonnet, sonnet46, sonnet46_cached, haiku)`,
	default: 'sonnet46',
},
		version: {
	type: 'string',
	description: `Summary length (simple, standard, or enhanced)`,
	default: 'standard',
},
		priority: {
	type: 'number',
	description: `Task priority (0-9, higher is more urgent)`,
	default: 5,
	maximum: 9,
	minimum: 0,
},
	},
} as const;

export const $Body_requests_request_upload_csv = {
	properties: {
		csv_file: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $Body_requests_request_upload_csv_no_partner_rules = {
	properties: {
		file: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $Body_uploads_upload_files = {
	properties: {
		referral_id: {
	type: 'number',
	isRequired: true,
},
		files: {
	type: 'array',
	contains: {
	type: 'string',
},
	isRequired: true,
},
	},
} as const;

export const $BulkOperationConfigCreate = {
	description: `Model for creating new bulk operation configurations.`,
	properties: {
		config_name: {
	type: 'string',
	description: `Configuration name (default, admin, etc.)`,
	default: 'default',
	maxLength: 100,
},
		max_operations_per_hour: {
	type: 'number',
	description: `Maximum operations per hour per user`,
	default: 5,
	minimum: 1,
},
		max_concurrent_operations: {
	type: 'number',
	description: `Maximum concurrent operations system-wide`,
	default: 3,
	minimum: 1,
},
		operation_timeout_hours: {
	type: 'number',
	description: `Operation timeout in hours`,
	default: 1,
	minimum: 1,
},
		role_overrides: {
	type: 'any-of',
	description: `Role-specific bulk operation limits`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		enabled: {
	type: 'boolean',
	description: `Whether bulk operation limits are enabled`,
	default: true,
},
		description: {
	type: 'any-of',
	description: `Description of the bulk operation limits`,
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
	},
} as const;

export const $BulkOperationConfigPublic = {
	description: `Public model for bulk operation configurations.`,
	properties: {
		config_name: {
	type: 'string',
	description: `Configuration name (default, admin, etc.)`,
	default: 'default',
	maxLength: 100,
},
		max_operations_per_hour: {
	type: 'number',
	description: `Maximum operations per hour per user`,
	default: 5,
	minimum: 1,
},
		max_concurrent_operations: {
	type: 'number',
	description: `Maximum concurrent operations system-wide`,
	default: 3,
	minimum: 1,
},
		operation_timeout_hours: {
	type: 'number',
	description: `Operation timeout in hours`,
	default: 1,
	minimum: 1,
},
		role_overrides: {
	type: 'any-of',
	description: `Role-specific bulk operation limits`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		enabled: {
	type: 'boolean',
	description: `Whether bulk operation limits are enabled`,
	default: true,
},
		description: {
	type: 'any-of',
	description: `Description of the bulk operation limits`,
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updated_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
	},
} as const;

export const $BulkOperationConfigUpdate = {
	description: `Model for updating bulk operation configurations.`,
	properties: {
		max_operations_per_hour: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		max_concurrent_operations: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		operation_timeout_hours: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		role_overrides: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		enabled: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $BulkOperationConfigsPublic = {
	description: `Public model for list of bulk operation configurations.`,
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'BulkOperationConfigPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $BulkOperationPublic = {
	properties: {
		id: {
	type: 'number',
	isRequired: true,
},
		user_id: {
	type: 'number',
	isRequired: true,
},
		status: {
	type: 'string',
	isRequired: true,
},
		total_referrals: {
	type: 'number',
	isRequired: true,
},
		processed_count: {
	type: 'number',
	isRequired: true,
},
		successful_count: {
	type: 'number',
	isRequired: true,
},
		failed_count: {
	type: 'number',
	isRequired: true,
},
		configuration: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
	isRequired: true,
},
		task_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		started_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
	isRequired: true,
},
		completed_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
	isRequired: true,
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updated_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		progress_percentage: {
	type: 'number',
	isRequired: true,
},
		errors: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
	},
} as const;

export const $CallAnalysisJobPublic = {
	properties: {
		partnerId: {
	type: 'number',
	isRequired: true,
},
		submittedByUserId: {
	type: 'number',
	isRequired: true,
},
		workflowId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		callReference: {
	type: 'string',
	isRequired: true,
	maxLength: 128,
},
		callDate: {
	type: 'string',
	isRequired: true,
	format: 'date',
},
		originalFilename: {
	type: 'string',
	isRequired: true,
	maxLength: 512,
},
		audioStorageKey: {
	type: 'string',
	isRequired: true,
	maxLength: 1024,
},
		contentType: {
	type: 'string',
	isRequired: true,
	maxLength: 128,
},
		status: {
	type: 'string',
	default: 'uploaded',
	maxLength: 30,
},
		transcriptText: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		formattedTranscriptText: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		deepgramRawResponse: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		deepgramRequestId: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		intakeId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		batchId: {
	type: 'any-of',
	description: `Groups calls belonging to one multi-call audit batch; NULL for single-call jobs`,
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		lastError: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		transcribingDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		completedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
		createdDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		analysisResult: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
	},
} as const;

export const $CallAnalysisJobsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'CallAnalysisJobPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $CallAnalysisWorkflowOption = {
	properties: {
		id: {
	type: 'number',
	isRequired: true,
},
		workflowKey: {
	type: 'string',
	isRequired: true,
},
		displayName: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $CallAnalysisWorkflowsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'CallAnalysisWorkflowOption',
	},
	isRequired: true,
},
	},
} as const;

export const $CallAuditBatchSummary = {
	properties: {
		batchId: {
	type: 'string',
	isRequired: true,
},
		status: {
	type: 'string',
	isRequired: true,
},
		clientReference: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		callAgentName: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		createdAt: {
	properties: {
	},
	isRequired: true,
},
		callCount: {
	type: 'number',
	isRequired: true,
},
		passFail: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $CallAuditBatchesPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'CallAuditBatchSummary',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $CallAuditConfigPublic = {
	description: `Public model for a call-audit binding.`,
	properties: {
		partnerId: {
	type: 'number',
	description: `Partner this call-audit binding applies to`,
	isRequired: true,
},
		reviewAgentKey: {
	type: 'string',
	description: `ai_prompt_config agent_key used for the review LLM step`,
	default: 'call-audit-quote-verification',
	maxLength: 100,
},
		engineKey: {
	type: 'string',
	description: `workflow-engine key used for the deterministic prepare/finalize steps`,
	default: 'call_audit_v1',
	maxLength: 100,
},
		reportTemplateId: {
	type: 'any-of',
	description: `ReportTemplate used to render output; null falls back to the built-in layout`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		isActive: {
	type: 'boolean',
	description: `Whether this binding is applied (false = use built-in defaults)`,
	default: true,
},
		id: {
	type: 'number',
	isRequired: true,
},
		createdDatetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $CallAuditConfigUpsert = {
	description: `Model for creating/updating a per-partner call-audit binding.`,
	properties: {
		reviewAgentKey: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		engineKey: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		reportTemplateId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		isActive: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $CallAuditRerunRequest = {
	properties: {
		sourceBatchId: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $CategoryRollupPublic = {
	properties: {
		categoryId: {
	type: 'string',
	isRequired: true,
},
		label: {
	type: 'string',
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
		pct: {
	type: 'number',
	isRequired: true,
},
		topAgents: {
	type: 'array',
	contains: {
	type: 'string',
},
	isRequired: true,
},
		exampleReferralIds: {
	type: 'array',
	contains: {
	type: 'number',
},
	isRequired: true,
},
	},
} as const;

export const $Circs_Grade = {
	properties: {
		createdDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		grade: {
	type: 'string',
	isRequired: true,
},
		desc: {
	type: 'string',
	isRequired: true,
},
		id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Circs_GradeCreate = {
	properties: {
		grade: {
	type: 'string',
	isRequired: true,
},
		desc: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $Circs_GradePublic = {
	properties: {
		grade: {
	type: 'string',
	isRequired: true,
},
		desc: {
	type: 'string',
	isRequired: true,
},
		id: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $Circs_GradeUpdate = {
	properties: {
		grade: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		desc: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Circs_GradesPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'Circs_GradePublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $Claim = {
	properties: {
		createdDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		client_firstname: {
	type: 'string',
	isRequired: true,
},
		client_lastname: {
	type: 'string',
	isRequired: true,
},
		client_address_1: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_address_town: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_address_postcode: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_vehicle_reg: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_insurer: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_insurer_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		client_insurer_policyno: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_phone: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_mobile: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'email',
}, {
	type: 'null',
}],
},
		authority_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		plate_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		accident_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		accident_time: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'time',
}, {
	type: 'null',
}],
},
		accident_location: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		accident_circs: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_firstname: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_lastname: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_1: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_town: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_postcode: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_vehicle_reg: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_insurer: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_insurer_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		tp_insurer_polcyno: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_phone: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_mobile: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		referral_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		circs_grade_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		client_dob: {
	type: 'any-of',
	description: `Client's date of birth`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		client_occupation: {
	type: 'any-of',
	description: `Client's occupation`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		purpose_of_journey: {
	type: 'any-of',
	description: `Purpose of journey`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		pre_existing_damage: {
	type: 'any-of',
	description: `Pre-existing damage`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_damage_description: {
	type: 'any-of',
	description: `Description of client's damage`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		no_of_passengers_clients: {
	type: 'any-of',
	description: `Number of passengers Clients`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		client_speed: {
	type: 'any-of',
	description: `Client's speed`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		any_witnesses: {
	type: 'any-of',
	description: `Were there any witnesses`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		weather_conditions: {
	type: 'any-of',
	description: `Weather conditions`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		source_liability: {
	type: 'any-of',
	description: `Source of liability`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emergency_service_attend: {
	type: 'any-of',
	description: `Emergency service attended`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		police_attended: {
	type: 'any-of',
	description: `Did police attend`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		fire_brigade_attended: {
	type: 'any-of',
	description: `Did fire brigade attend`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		ambulance_attended: {
	type: 'any-of',
	description: `Did ambulance attend`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		police_station_name: {
	type: 'any-of',
	description: `Name of Police station`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		police_officer_name: {
	type: 'any-of',
	description: `Name of Police officer`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		police_reference: {
	type: 'any-of',
	description: `Police Reference`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		policy_cover: {
	type: 'any-of',
	description: `Policy Cover`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		policy_excess: {
	type: 'any-of',
	description: `Policy Excess`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		policy_start_date: {
	type: 'any-of',
	description: `Policy Start Date`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		policy_expiry_date: {
	type: 'any-of',
	description: `Policy Expires Date`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		vat_registered: {
	type: 'any-of',
	description: `VAT Registered`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		policy_vehicle_use: {
	type: 'any-of',
	description: `Policy vehicle use`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_vehicle_drivable: {
	type: 'any-of',
	description: `Client Vehicle Drivable`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		client_vehicle_secure: {
	type: 'any-of',
	description: `Client Vehicle Secure`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		client_vehicle_location: {
	type: 'any-of',
	description: `Client Vehicle Location`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		storage: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		storage_location: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ClaimCreate = {
	properties: {
		client_firstname: {
	type: 'string',
	isRequired: true,
},
		client_lastname: {
	type: 'string',
	isRequired: true,
},
		client_address_1: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_address_town: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_address_postcode: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_vehicle_reg: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_insurer: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_insurer_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		client_insurer_policyno: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_phone: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_mobile: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'email',
}, {
	type: 'null',
}],
},
		authority_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		plate_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		accident_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		accident_time: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'time',
}, {
	type: 'null',
}],
},
		accident_location: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		accident_circs: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_firstname: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_lastname: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_1: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_town: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_postcode: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_vehicle_reg: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_insurer: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_insurer_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		tp_insurer_polcyno: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_phone: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_mobile: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		referral_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		circs_grade_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		client_dob: {
	type: 'any-of',
	description: `Client's date of birth`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		client_occupation: {
	type: 'any-of',
	description: `Client's occupation`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		purpose_of_journey: {
	type: 'any-of',
	description: `Purpose of journey`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		pre_existing_damage: {
	type: 'any-of',
	description: `Pre-existing damage`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_damage_description: {
	type: 'any-of',
	description: `Description of client's damage`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		no_of_passengers_clients: {
	type: 'any-of',
	description: `Number of passengers Clients`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		client_speed: {
	type: 'any-of',
	description: `Client's speed`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		any_witnesses: {
	type: 'any-of',
	description: `Were there any witnesses`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		weather_conditions: {
	type: 'any-of',
	description: `Weather conditions`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		source_liability: {
	type: 'any-of',
	description: `Source of liability`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emergency_service_attend: {
	type: 'any-of',
	description: `Emergency service attended`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		police_attended: {
	type: 'any-of',
	description: `Did police attend`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		fire_brigade_attended: {
	type: 'any-of',
	description: `Did fire brigade attend`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		ambulance_attended: {
	type: 'any-of',
	description: `Did ambulance attend`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		police_station_name: {
	type: 'any-of',
	description: `Name of Police station`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		police_officer_name: {
	type: 'any-of',
	description: `Name of Police officer`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		police_reference: {
	type: 'any-of',
	description: `Police Reference`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		policy_cover: {
	type: 'any-of',
	description: `Policy Cover`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		policy_excess: {
	type: 'any-of',
	description: `Policy Excess`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		policy_start_date: {
	type: 'any-of',
	description: `Policy Start Date`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		policy_expiry_date: {
	type: 'any-of',
	description: `Policy Expires Date`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		vat_registered: {
	type: 'any-of',
	description: `VAT Registered`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		policy_vehicle_use: {
	type: 'any-of',
	description: `Policy vehicle use`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_vehicle_drivable: {
	type: 'any-of',
	description: `Client Vehicle Drivable`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		client_vehicle_secure: {
	type: 'any-of',
	description: `Client Vehicle Secure`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		client_vehicle_location: {
	type: 'any-of',
	description: `Client Vehicle Location`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		storage: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		storage_location: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ClaimPublic = {
	properties: {
		client_firstname: {
	type: 'string',
	isRequired: true,
},
		client_lastname: {
	type: 'string',
	isRequired: true,
},
		client_address_1: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_address_town: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_address_postcode: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_vehicle_reg: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_insurer: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_insurer_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		client_insurer_policyno: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_phone: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_mobile: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'email',
}, {
	type: 'null',
}],
},
		authority_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		plate_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		accident_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		accident_time: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'time',
}, {
	type: 'null',
}],
},
		accident_location: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		accident_circs: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_firstname: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_lastname: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_1: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_town: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_postcode: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_vehicle_reg: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_insurer: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_insurer_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		tp_insurer_polcyno: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_phone: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_mobile: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		referral_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		circs_grade_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		client_dob: {
	type: 'any-of',
	description: `Client's date of birth`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		client_occupation: {
	type: 'any-of',
	description: `Client's occupation`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		purpose_of_journey: {
	type: 'any-of',
	description: `Purpose of journey`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		pre_existing_damage: {
	type: 'any-of',
	description: `Pre-existing damage`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_damage_description: {
	type: 'any-of',
	description: `Description of client's damage`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		no_of_passengers_clients: {
	type: 'any-of',
	description: `Number of passengers Clients`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		client_speed: {
	type: 'any-of',
	description: `Client's speed`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		any_witnesses: {
	type: 'any-of',
	description: `Were there any witnesses`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		weather_conditions: {
	type: 'any-of',
	description: `Weather conditions`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		source_liability: {
	type: 'any-of',
	description: `Source of liability`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emergency_service_attend: {
	type: 'any-of',
	description: `Emergency service attended`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		police_attended: {
	type: 'any-of',
	description: `Did police attend`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		fire_brigade_attended: {
	type: 'any-of',
	description: `Did fire brigade attend`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		ambulance_attended: {
	type: 'any-of',
	description: `Did ambulance attend`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		police_station_name: {
	type: 'any-of',
	description: `Name of Police station`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		police_officer_name: {
	type: 'any-of',
	description: `Name of Police officer`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		police_reference: {
	type: 'any-of',
	description: `Police Reference`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		policy_cover: {
	type: 'any-of',
	description: `Policy Cover`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		policy_excess: {
	type: 'any-of',
	description: `Policy Excess`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		policy_start_date: {
	type: 'any-of',
	description: `Policy Start Date`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		policy_expiry_date: {
	type: 'any-of',
	description: `Policy Expires Date`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		vat_registered: {
	type: 'any-of',
	description: `VAT Registered`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		policy_vehicle_use: {
	type: 'any-of',
	description: `Policy vehicle use`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_vehicle_drivable: {
	type: 'any-of',
	description: `Client Vehicle Drivable`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		client_vehicle_secure: {
	type: 'any-of',
	description: `Client Vehicle Secure`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		client_vehicle_location: {
	type: 'any-of',
	description: `Client Vehicle Location`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		storage: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		storage_location: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		claimscore: {
	type: 'any-of',
	contains: [{
	type: 'Claim_Score',
}, {
	type: 'null',
}],
},
		annieresult: {
	type: 'any-of',
	contains: [{
	type: 'Annie_Result',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ClaimSummaryDetailPublic = {
	properties: {
		id: {
	type: 'number',
	isRequired: true,
},
		referral_id: {
	type: 'number',
	isRequired: true,
},
		user_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		task_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		tenant_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		workflow_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		version: {
	type: 'string',
	isRequired: true,
},
		priority: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		summary: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		status: {
	type: 'string',
	isRequired: true,
},
		error_message: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		generation_time: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		cache_hit: {
	type: 'boolean',
	isRequired: true,
},
		model_version: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updated_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		system_prompt: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		user_prompt: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		context_data: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;

export const $ClaimSummaryPublic = {
	properties: {
		id: {
	type: 'number',
	isRequired: true,
},
		referral_id: {
	type: 'number',
	isRequired: true,
},
		user_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		task_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		tenant_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		workflow_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		version: {
	type: 'string',
	isRequired: true,
},
		priority: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		summary: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		status: {
	type: 'string',
	isRequired: true,
},
		error_message: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		generation_time: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		cache_hit: {
	type: 'boolean',
	isRequired: true,
},
		model_version: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updated_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
	},
} as const;

export const $ClaimSummaryRecentRunPublic = {
	properties: {
		id: {
	type: 'number',
	isRequired: true,
},
		referralId: {
	type: 'number',
	isRequired: true,
},
		sourceRef: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		hireStatus: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		taskId: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		userId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		tenantId: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		workflowId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		version: {
	type: 'string',
	isRequired: true,
},
		status: {
	type: 'string',
	isRequired: true,
},
		summaryExcerpt: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		errorMessage: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		generationTime: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		cacheHit: {
	type: 'boolean',
	isRequired: true,
},
		modelVersion: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		createdDatetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updatedDatetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		feedbackRating: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ClaimSummaryRecentRunsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'ClaimSummaryRecentRunPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $ClaimUpdate = {
	properties: {
		client_firstname: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_lastname: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_address_1: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_address_town: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_address_postcode: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_vehicle_reg: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_insurer: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_insurer_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		client_insurer_policyno: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_phone: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_mobile: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'email',
}, {
	type: 'null',
}],
},
		authority_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		plate_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		accident_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		accident_time: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'time',
}, {
	type: 'null',
}],
},
		accident_location: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		accident_circs: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_firstname: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_lastname: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_1: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_town: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_postcode: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_vehicle_reg: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_insurer: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_insurer_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		tp_insurer_polcyno: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_phone: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_mobile: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		referral_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		circs_grade_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		client_dob: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		client_occupation: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		purpose_of_journey: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		pre_existing_damage: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_damage_description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		no_of_passengers_clients: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		client_speed: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		any_witnesses: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		weather_conditions: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		source_liability: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emergency_service_attend: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		police_attended: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		fire_brigade_attended: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		ambulance_attended: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		police_station_name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		police_officer_name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		police_reference: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		policy_cover: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		policy_excess: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		policy_start_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		policy_expiry_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		vat_registered: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		policy_vehicle_use: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_vehicle_drivable: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		client_vehicle_secure: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		client_vehicle_location: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		storage: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		storage_location: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		claimscore: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		annieresult: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Claim_Score = {
	properties: {
		createdDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		claim_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		completeness_CL_score: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		completeness_TP_score: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		tpreg_score: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		timeliness_score: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		total_score: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		final_score: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ClaimsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'ClaimPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $CloneRequest = {
	properties: {
		target_partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $CompareRequest = {
	properties: {
		referral_id: {
	type: 'number',
	isRequired: true,
},
		workflow_a: {
	type: 'WorkflowSpec',
	isRequired: true,
},
		workflow_b: {
	type: 'WorkflowSpec',
	isRequired: true,
},
	},
} as const;

export const $ComplaintCreate = {
	properties: {
		referralId: {
	type: 'number',
	isRequired: true,
},
		partnerId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		summary: {
	type: 'string',
	isRequired: true,
	maxLength: 500,
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		status: {
	type: 'ComplaintStatus',
	default: 'Open',
},
		notifySource: {
	type: 'boolean',
	default: false,
},
		notifySuppliers: {
	type: 'array',
	contains: {
	type: 'number',
},
},
		notifyWysehub: {
	type: 'boolean',
	default: false,
},
	},
} as const;

export const $ComplaintPublic = {
	properties: {
		id: {
	type: 'number',
	isRequired: true,
},
		referralId: {
	type: 'number',
	isRequired: true,
},
		partnerId: {
	type: 'number',
	isRequired: true,
},
		summary: {
	type: 'string',
	isRequired: true,
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		status: {
	type: 'ComplaintStatus',
	isRequired: true,
},
		dateOpened: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		dateClosed: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
	isRequired: true,
},
		resolutionNotes: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		createdDatetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updatedDatetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		partner: {
	type: 'any-of',
	contains: [{
	type: 'PartnerPublic',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ComplaintStatus = {
	type: 'Enum',
	enum: ['Open','InProgress','Resolved','Closed',],
} as const;

export const $ComplaintUpdate = {
	properties: {
		summary: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'ComplaintStatus',
}, {
	type: 'null',
}],
},
		resolutionNotes: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		dateClosed: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ComplaintsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'ComplaintPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $CreateRequest = {
	properties: {
		partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		workflow_key: {
	type: 'string',
	isRequired: true,
},
		definition: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
	isRequired: true,
},
		display_name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		status: {
	type: 'string',
	default: 'sandbox',
},
	},
} as const;

export const $EditRequest = {
	properties: {
		definition: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
	isRequired: true,
},
		display_name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $FeedbackRequestPublic = {
	properties: {
		agentRunId: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		referralId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		agentKey: {
	type: 'string',
	isRequired: true,
	maxLength: 100,
},
		recipientEmail: {
	type: 'string',
	isRequired: true,
	maxLength: 255,
},
		promptSource: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 20,
}, {
	type: 'null',
}],
},
		promptAppSlug: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		promptVariantSlug: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		promptEnvironment: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 50,
}, {
	type: 'null',
}],
},
		promptVersionNumber: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		status: {
	type: 'string',
	description: `pending, responded, expired`,
	default: 'pending',
	maxLength: 20,
},
		expiresAt: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		respondedAt: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		token: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		created_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
	},
} as const;

export const $FeedbackResponsePublic = {
	properties: {
		feedbackRequestId: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		rating: {
	type: 'string',
	description: `up or down`,
	isRequired: true,
	maxLength: 10,
},
		reasonCode: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 50,
}, {
	type: 'null',
}],
},
		comment: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		submittedByEmail: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		submittedAt: {
	type: 'string',
	format: 'date-time',
},
		id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
	},
} as const;

export const $HTTPValidationError = {
	properties: {
		detail: {
	type: 'array',
	contains: {
		type: 'ValidationError',
	},
},
	},
} as const;

export const $Input = {
	properties: {
		text: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $InsurerCreate = {
	properties: {
		name: {
	type: 'string',
	isRequired: true,
	maxLength: 255,
},
	},
} as const;

export const $InsurerPublic = {
	properties: {
		name: {
	type: 'string',
	isRequired: true,
	maxLength: 255,
},
		id: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $InsurerUpdate = {
	properties: {
		name: {
	type: 'string',
	isRequired: true,
	maxLength: 255,
},
	},
} as const;

export const $InsurersPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'InsurerPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $Interested_Person = {
	properties: {
		createdDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		ip_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		firstname: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		lastname: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		address_1: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		address_town: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		address_postcode: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		vehicle_reg: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		vehicle_make: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		vehicle_model: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		insurer: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		insurer_policyno: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		phone: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		mobile: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'email',
	maxLength: 254,
}, {
	type: 'null',
}],
},
		id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Interested_PersonBase = {
	properties: {
		referral_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		ip_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		firstname: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		lastname: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		address_1: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		address_town: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		address_postcode: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		vehicle_reg: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		vehicle_make: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		vehicle_model: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		insurer: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		insurer_policyno: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		phone: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		mobile: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'email',
	maxLength: 254,
}, {
	type: 'null',
}],
},
	},
} as const;

export const $InvoiceLinePublic = {
	properties: {
		invoice_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		referral_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		referral_allocation_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		description: {
	type: 'string',
	isRequired: true,
},
		rate: {
	type: 'number',
	default: 0,
},
		amount: {
	type: 'number',
	isRequired: true,
},
		billed_amount: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		discount_percentage: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 50,
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 50,
}, {
	type: 'null',
}],
},
		paid_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $InvoicePublic = {
	properties: {
		partner_id: {
	type: 'number',
	isRequired: true,
},
		billing_date: {
	type: 'string',
	isRequired: true,
	format: 'date',
},
		total_amount: {
	type: 'number',
	isRequired: true,
},
		issued_date: {
	type: 'string',
	format: 'date-time',
},
		status: {
	type: 'string',
	default: 'Pending',
	maxLength: 20,
},
		file_location: {
	type: 'any-of',
	description: `Location of the invoice file`,
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		xero_inv_no: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		xero_invoice_id: {
	type: 'any-of',
	description: `Xero internal invoice ID/GUID for API requests`,
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
		invoice_lines: {
	type: 'array',
	contains: {
		type: 'InvoiceLinePublic',
	},
	isRequired: true,
},
	},
} as const;

export const $LoginResponse = {
	properties: {
		accessToken: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tokenType: {
	type: 'string',
	isRequired: true,
},
		requiresOtp: {
	type: 'boolean',
	isRequired: true,
},
		message: {
	type: 'string',
	isRequired: true,
},
		loginHistoryId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		userId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		csrfToken: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Message = {
	properties: {
		message: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $MetabaseEmbedTokenPublic = {
	properties: {
		iframeUrl: {
	type: 'string',
	isRequired: true,
},
		expiresAt: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		appliedPartnerId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $MetabaseEmbedTokenRequest = {
	properties: {
		catalogId: {
	type: 'number',
	isRequired: true,
},
		partnerId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		params: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	type: 'array',
	contains: {
	type: 'string',
},
},
}, {
	type: 'null',
}],
},
	},
} as const;

export const $MetabaseReportCatalogAvailable = {
	properties: {
		id: {
	type: 'number',
	isRequired: true,
},
		name: {
	type: 'string',
	isRequired: true,
},
		resourceType: {
	type: 'MetabaseReportCatalogResourceType',
	isRequired: true,
},
		partnerParamSlug: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $MetabaseReportCatalogAvailablePublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'MetabaseReportCatalogAvailable',
	},
	isRequired: true,
},
	},
} as const;

export const $MetabaseReportCatalogCreate = {
	properties: {
		name: {
	type: 'string',
	description: `Friendly display name`,
	isRequired: true,
	maxLength: 200,
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 2000,
}, {
	type: 'null',
}],
},
		resourceType: {
	type: 'MetabaseReportCatalogResourceType',
	description: `Metabase resource type: dashboard or card`,
	isRequired: true,
},
		metabaseId: {
	type: 'number',
	description: `Metabase dashboard or card ID`,
	isRequired: true,
},
		partnerParamSlug: {
	type: 'string',
	description: `Metabase locked filter slug for partner scoping`,
	default: 'partner_id',
	maxLength: 100,
},
		isActive: {
	type: 'boolean',
	default: true,
},
		partnerIds: {
	type: 'array',
	contains: {
	type: 'number',
},
},
	},
} as const;

export const $MetabaseReportCatalogPublic = {
	properties: {
		name: {
	type: 'string',
	description: `Friendly display name`,
	isRequired: true,
	maxLength: 200,
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 2000,
}, {
	type: 'null',
}],
},
		resourceType: {
	type: 'MetabaseReportCatalogResourceType',
	description: `Metabase resource type: dashboard or card`,
	isRequired: true,
},
		metabaseId: {
	type: 'number',
	description: `Metabase dashboard or card ID`,
	isRequired: true,
},
		partnerParamSlug: {
	type: 'string',
	description: `Metabase locked filter slug for partner scoping`,
	default: 'partner_id',
	maxLength: 100,
},
		isActive: {
	type: 'boolean',
	default: true,
},
		id: {
	type: 'number',
	isRequired: true,
},
		partnerIds: {
	type: 'array',
	contains: {
	type: 'number',
},
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updated_datetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $MetabaseReportCatalogResourceType = {
	type: 'Enum',
	enum: ['dashboard','card',],
} as const;

export const $MetabaseReportCatalogUpdate = {
	properties: {
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		resource_type: {
	type: 'any-of',
	contains: [{
	type: 'MetabaseReportCatalogResourceType',
}, {
	type: 'null',
}],
},
		metabaseId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		partnerParamSlug: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		isActive: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		partnerIds: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'number',
},
}, {
	type: 'null',
}],
},
	},
} as const;

export const $MetabaseReportCatalogsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'MetabaseReportCatalogPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $MetabaseReportScheduleCreate = {
	description: `Model for creating Metabase report schedules.`,
	properties: {
		name: {
	type: 'string',
	description: `Friendly name for the report schedule`,
	isRequired: true,
	maxLength: 200,
},
		card_id: {
	type: 'number',
	description: `Metabase card ID to export`,
	isRequired: true,
},
		email_to: {
	type: 'string',
	description: `Comma/semicolon separated recipient list`,
	isRequired: true,
	maxLength: 1000,
},
		subject: {
	type: 'any-of',
	description: `Email subject override`,
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		run_hour: {
	type: 'number',
	description: `UTC hour to send (0-23)`,
	isRequired: true,
	maximum: 23,
	minimum: 0,
},
		run_minute: {
	type: 'number',
	description: `UTC minute to send (0-59)`,
	isRequired: true,
	maximum: 59,
	minimum: 0,
},
		is_enabled: {
	type: 'boolean',
	description: `Whether the schedule is active`,
	default: true,
},
	},
} as const;

export const $MetabaseReportSchedulePublic = {
	description: `Public model for Metabase report schedules.`,
	properties: {
		name: {
	type: 'string',
	description: `Friendly name for the report schedule`,
	isRequired: true,
	maxLength: 200,
},
		card_id: {
	type: 'number',
	description: `Metabase card ID to export`,
	isRequired: true,
},
		email_to: {
	type: 'string',
	description: `Comma/semicolon separated recipient list`,
	isRequired: true,
	maxLength: 1000,
},
		subject: {
	type: 'any-of',
	description: `Email subject override`,
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		run_hour: {
	type: 'number',
	description: `UTC hour to send (0-23)`,
	isRequired: true,
	maximum: 23,
	minimum: 0,
},
		run_minute: {
	type: 'number',
	description: `UTC minute to send (0-59)`,
	isRequired: true,
	maximum: 59,
	minimum: 0,
},
		is_enabled: {
	type: 'boolean',
	description: `Whether the schedule is active`,
	default: true,
},
		id: {
	type: 'number',
	isRequired: true,
},
		last_sent_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updated_datetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $MetabaseReportScheduleUpdate = {
	description: `Model for updating Metabase report schedules.`,
	properties: {
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		card_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		email_to: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		subject: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		run_hour: {
	type: 'any-of',
	contains: [{
	type: 'number',
	maximum: 23,
	minimum: 0,
}, {
	type: 'null',
}],
},
		run_minute: {
	type: 'any-of',
	contains: [{
	type: 'number',
	maximum: 59,
	minimum: 0,
}, {
	type: 'null',
}],
},
		is_enabled: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		last_sent_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $MetabaseReportSchedulesPublic = {
	description: `Public model for list of Metabase report schedules.`,
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'MetabaseReportSchedulePublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $MyPagesResponse = {
	properties: {
		pages: {
	type: 'array',
	contains: {
	type: 'string',
},
	isRequired: true,
},
	},
} as const;

export const $NewPassword = {
	properties: {
		token: {
	type: 'string',
	isRequired: true,
},
		new_password: {
	type: 'string',
	isRequired: true,
	maxLength: 40,
	minLength: 8,
},
	},
} as const;

export const $Note = {
	properties: {
		createdDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		referralId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		complaintId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		note: {
	type: 'string',
	isRequired: true,
},
		createdBy: {
	type: 'number',
	isRequired: true,
},
		noteDate: {
	type: 'string',
	format: 'date-time',
},
		id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $NoteCreate = {
	properties: {
		referralId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		complaintId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		note: {
	type: 'string',
	isRequired: true,
},
		noteDate: {
	type: 'string',
	format: 'date-time',
},
		notifySource: {
	type: 'boolean',
	default: false,
},
		notifySuppliers: {
	type: 'array',
	contains: {
	type: 'number',
},
},
		notifyWysehub: {
	type: 'boolean',
	default: false,
},
	},
} as const;

export const $NotePublic = {
	properties: {
		id: {
	type: 'number',
	isRequired: true,
},
		referral_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		complaint_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		note: {
	type: 'string',
	isRequired: true,
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		created_by_user: {
	type: 'any-of',
	contains: [{
	type: 'UserPublicBasic',
}, {
	type: 'null',
}],
},
		note_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $NotePublicBasic = {
	properties: {
		id: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $NotesBatchCreate = {
	properties: {
		notes: {
	type: 'array',
	contains: {
		type: 'NoteCreate',
	},
	isRequired: true,
},
	},
} as const;

export const $NotesBatchError = {
	properties: {
		index: {
	type: 'number',
	isRequired: true,
},
		referralId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		detail: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $NotesBatchResult = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'NotePublicBasic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
		errors: {
	type: 'array',
	contains: {
		type: 'NotesBatchError',
	},
},
	},
} as const;

export const $NotesPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'NotePublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $Partner = {
	properties: {
		createdDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		name: {
	type: 'string',
	isRequired: true,
},
		address1: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		addressTown: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		addressPostcode: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		supplierBaseRate: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		Tel: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		updatesEmail: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		accountsEmail: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		newclaimsEmail: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		receiveClaimsVia: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tier: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		xeroContactNumber: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		isActive: {
	type: 'boolean',
	default: true,
},
		id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $PartnerApiBillingConfigCreate = {
	properties: {
		partner_id: {
	type: 'number',
	isRequired: true,
},
		billing_type: {
	type: 'string',
	isRequired: true,
	maxLength: 20,
},
		is_active: {
	type: 'boolean',
	default: true,
},
		pricing_tiers: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
},
}, {
	type: 'null',
}],
},
		discount_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 20,
}, {
	type: 'null',
}],
},
		discount_duration_months: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		discount_percentage: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		discount_start_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		prepaid_balance: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		prepaid_requests_remaining: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		billing_day: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		max_monthly_charge: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		minimum_combined_invoice_total: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $PartnerApiBillingConfigPublic = {
	properties: {
		partner_id: {
	type: 'number',
	isRequired: true,
},
		billing_type: {
	type: 'string',
	isRequired: true,
	maxLength: 20,
},
		is_active: {
	type: 'boolean',
	default: true,
},
		pricing_tiers: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
},
}, {
	type: 'null',
}],
},
		discount_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 20,
}, {
	type: 'null',
}],
},
		discount_duration_months: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		discount_percentage: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		discount_start_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		prepaid_balance: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		prepaid_requests_remaining: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		billing_day: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		max_monthly_charge: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		minimum_combined_invoice_total: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $PartnerApiBillingConfigUpdate = {
	properties: {
		partner_id: {
	type: 'number',
	isRequired: true,
},
		billing_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		is_active: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		pricing_tiers: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
},
}, {
	type: 'null',
}],
},
		discount_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 20,
}, {
	type: 'null',
}],
},
		discount_duration_months: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		discount_percentage: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		discount_start_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		prepaid_balance: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		prepaid_requests_remaining: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		billing_day: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		max_monthly_charge: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		minimum_combined_invoice_total: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $PartnerApiBillingConfigsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'PartnerApiBillingConfigPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $PartnerCreate = {
	properties: {
		name: {
	type: 'string',
	isRequired: true,
},
		address1: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		addressTown: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		addressPostcode: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		supplierBaseRate: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		Tel: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		updatesEmail: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		accountsEmail: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		newclaimsEmail: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		receiveClaimsVia: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tier: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		xeroContactNumber: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		isActive: {
	type: 'boolean',
	default: true,
},
	},
} as const;

export const $PartnerForNotification = {
	properties: {
		id: {
	type: 'number',
	isRequired: true,
},
		name: {
	type: 'string',
	isRequired: true,
},
		email: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		updates_email: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $PartnerIssueRollupPublic = {
	properties: {
		fromDate: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		toDate: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		partnerId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		partnerName: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		totalRuns: {
	type: 'number',
	isRequired: true,
},
		urgentCount: {
	type: 'number',
	isRequired: true,
},
		urgentPct: {
	type: 'number',
	isRequired: true,
},
		avgHandlingScore: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		topCategories: {
	type: 'array',
	contains: {
		type: 'CategoryRollupPublic',
	},
	isRequired: true,
},
		byAgent: {
	type: 'dictionary',
	contains: {
	type: 'number',
},
	isRequired: true,
},
		byHireStatus: {
	type: 'dictionary',
	contains: {
	type: 'number',
},
	isRequired: true,
},
		byWorkflowKey: {
	type: 'dictionary',
	contains: {
	type: 'number',
},
	isRequired: true,
},
		unmappedSample: {
	type: 'array',
	contains: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
},
	isRequired: true,
},
	},
} as const;

export const $PartnerPublic = {
	properties: {
		name: {
	type: 'string',
	isRequired: true,
},
		address1: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		addressTown: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		addressPostcode: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		supplierBaseRate: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		Tel: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		updatesEmail: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		accountsEmail: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		newclaimsEmail: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		receiveClaimsVia: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tier: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		xeroContactNumber: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		isActive: {
	type: 'boolean',
	default: true,
},
		id: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $PartnerUpdate = {
	properties: {
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		address1: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		addressTown: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		addressPostcode: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		supplierBaseRate: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		Tel: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		updatesEmail: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		accountsEmail: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		newclaimsEmail: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		receiveClaimsVia: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tier: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		xeroContactNumber: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		isActive: {
	type: 'boolean',
	default: true,
},
	},
} as const;

export const $Partner_RuleCreate = {
	properties: {
		partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		circs_grade_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		veh_group_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		rule_name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		rule: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		vehicle_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		probability_threshold: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		outbound_email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'email',
	maxLength: 254,
}, {
	type: 'null',
}],
},
		outbound_phone: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		priority: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		partner_percents: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Partner_RulePublic = {
	properties: {
		partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		circs_grade_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		veh_group_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		rule_name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		rule: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		vehicle_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		probability_threshold: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		outbound_email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'email',
	maxLength: 254,
}, {
	type: 'null',
}],
},
		outbound_phone: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		priority: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
		partner: {
	type: 'Partner',
	isRequired: true,
},
		circs_grade: {
	type: 'any-of',
	contains: [{
	type: 'Circs_Grade',
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;

export const $Partner_RuleUpdate = {
	properties: {
		partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		circs_grade_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		veh_group_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		rule_name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		rule: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		vehicle_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		probability_threshold: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		outbound_email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'email',
	maxLength: 254,
}, {
	type: 'null',
}],
},
		outbound_phone: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		priority: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Partner_RulesPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'Partner_RulePublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $PartnersPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'PartnerPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $PerformanceMetric = {
	description: `Performance metric data from frontend.`,
	properties: {
		metric: {
	type: 'string',
	description: `Metric name (LCP, INP, CLS, etc.)`,
	isRequired: true,
},
		value: {
	type: 'number',
	description: `Metric value`,
	isRequired: true,
},
		rating: {
	type: 'string',
	description: `Performance rating (good, needs-improvement, poor)`,
	isRequired: true,
},
		timestamp: {
	type: 'number',
	description: `Timestamp when metric was recorded`,
	isRequired: true,
},
		url: {
	type: 'string',
	description: `URL where metric was recorded`,
	isRequired: true,
},
		userAgent: {
	type: 'string',
	description: `User agent string`,
	isRequired: true,
},
	},
} as const;

export const $PermissionCatalogItem = {
	properties: {
		key: {
	type: 'string',
	isRequired: true,
},
		operations: {
	type: 'array',
	contains: {
	type: 'string',
},
	isRequired: true,
},
		brand: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $PermissionCatalogResponse = {
	properties: {
		endpoints: {
	type: 'array',
	contains: {
		type: 'PermissionCatalogItem',
	},
	isRequired: true,
},
		pages: {
	type: 'array',
	contains: {
		type: 'PermissionCatalogItem',
	},
	isRequired: true,
},
	},
} as const;

export const $PrivacyPurgeResponse = {
	properties: {
		deleted: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $PrivacyRehydrateRequest = {
	properties: {
		scopeKey: {
	type: 'string',
	isRequired: true,
	maxLength: 255,
	minLength: 1,
},
		token: {
	type: 'string',
	isRequired: true,
	maxLength: 255,
	minLength: 1,
},
		justification: {
	type: 'string',
	isRequired: true,
	maxLength: 500,
	minLength: 8,
},
	},
} as const;

export const $PrivacyRehydrateResponse = {
	properties: {
		found: {
	type: 'boolean',
	isRequired: true,
},
		resolvedValue: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ProfilerStats = {
	properties: {
		active: {
	type: 'boolean',
	isRequired: true,
},
		tracked_patterns: {
	type: 'number',
	isRequired: true,
},
		slow_queries: {
	type: 'number',
	isRequired: true,
},
		n1_patterns: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $RateLimitConfigCreate = {
	description: `Model for creating new rate limiting configurations.`,
	properties: {
		endpoint_path: {
	type: 'string',
	description: `Endpoint path pattern (e.g., /api/v1/login/access-token)`,
	isRequired: true,
	maxLength: 255,
},
		method: {
	type: 'string',
	description: `HTTP method (GET, POST, PUT, DELETE, etc.)`,
	isRequired: true,
	maxLength: 10,
},
		strategy: {
	type: 'string',
	description: `Rate limiting strategy (redis, database, hybrid)`,
	default: 'redis',
	maxLength: 20,
},
		identifier_type: {
	type: 'string',
	description: `Identifier type (user, ip, api_key, path_user)`,
	default: 'user',
	maxLength: 20,
},
		resource_name: {
	type: 'string',
	description: `Resource name for rate limiting`,
	isRequired: true,
	maxLength: 100,
},
		default_requests: {
	type: 'number',
	description: `Default requests per window`,
	default: 100,
	minimum: 1,
},
		default_window_seconds: {
	type: 'number',
	description: `Default window in seconds`,
	default: 3600,
	minimum: 1,
},
		default_burst_allowance: {
	type: 'number',
	description: `Default burst allowance`,
	default: 0,
	minimum: 0,
},
		admin_requests: {
	type: 'any-of',
	description: `Admin requests per window`,
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		admin_window_seconds: {
	type: 'any-of',
	description: `Admin window in seconds`,
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		admin_burst_allowance: {
	type: 'any-of',
	description: `Admin burst allowance`,
	contains: [{
	type: 'number',
	minimum: 0,
}, {
	type: 'null',
}],
},
		role_overrides: {
	type: 'any-of',
	description: `Role-specific rate limit overrides`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		enabled: {
	type: 'boolean',
	description: `Whether rate limiting is enabled for this endpoint`,
	default: true,
},
		description: {
	type: 'any-of',
	description: `Description of the endpoint and its rate limits`,
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
	},
} as const;

export const $RateLimitConfigPublic = {
	description: `Public model for rate limiting configurations.`,
	properties: {
		endpoint_path: {
	type: 'string',
	description: `Endpoint path pattern (e.g., /api/v1/login/access-token)`,
	isRequired: true,
	maxLength: 255,
},
		method: {
	type: 'string',
	description: `HTTP method (GET, POST, PUT, DELETE, etc.)`,
	isRequired: true,
	maxLength: 10,
},
		strategy: {
	type: 'string',
	description: `Rate limiting strategy (redis, database, hybrid)`,
	default: 'redis',
	maxLength: 20,
},
		identifier_type: {
	type: 'string',
	description: `Identifier type (user, ip, api_key, path_user)`,
	default: 'user',
	maxLength: 20,
},
		resource_name: {
	type: 'string',
	description: `Resource name for rate limiting`,
	isRequired: true,
	maxLength: 100,
},
		default_requests: {
	type: 'number',
	description: `Default requests per window`,
	default: 100,
	minimum: 1,
},
		default_window_seconds: {
	type: 'number',
	description: `Default window in seconds`,
	default: 3600,
	minimum: 1,
},
		default_burst_allowance: {
	type: 'number',
	description: `Default burst allowance`,
	default: 0,
	minimum: 0,
},
		admin_requests: {
	type: 'any-of',
	description: `Admin requests per window`,
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		admin_window_seconds: {
	type: 'any-of',
	description: `Admin window in seconds`,
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		admin_burst_allowance: {
	type: 'any-of',
	description: `Admin burst allowance`,
	contains: [{
	type: 'number',
	minimum: 0,
}, {
	type: 'null',
}],
},
		role_overrides: {
	type: 'any-of',
	description: `Role-specific rate limit overrides`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		enabled: {
	type: 'boolean',
	description: `Whether rate limiting is enabled for this endpoint`,
	default: true,
},
		description: {
	type: 'any-of',
	description: `Description of the endpoint and its rate limits`,
	contains: [{
	type: 'string',
	maxLength: 500,
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updated_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
	},
} as const;

export const $RateLimitConfigUpdate = {
	description: `Model for updating rate limiting configurations.`,
	properties: {
		strategy: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		identifier_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		resource_name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		default_requests: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		default_window_seconds: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		default_burst_allowance: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 0,
}, {
	type: 'null',
}],
},
		admin_requests: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		admin_window_seconds: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		admin_burst_allowance: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 0,
}, {
	type: 'null',
}],
},
		role_overrides: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		enabled: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $RateLimitConfigsPublic = {
	description: `Public model for list of rate limiting configurations.`,
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'RateLimitConfigPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $ReferralCreate = {
	properties: {
		partnerSourceId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		partnerSupplierId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		authorityId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		claimId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		sourceOrigNote: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		sourceRef: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ReferralNotificationOptions = {
	properties: {
		source_partner: {
	type: 'any-of',
	contains: [{
	type: 'PartnerForNotification',
}, {
	type: 'null',
}],
},
		supplier_partners: {
	type: 'array',
	contains: {
		type: 'PartnerForNotification',
	},
	isRequired: true,
},
		source_ref: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ReferralPublic = {
	properties: {
		partnerSourceId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		partnerSupplierId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		authorityId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		claimId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		sourceOrigNote: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		sourceRef: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
		partner_source: {
	type: 'any-of',
	contains: [{
	type: 'Partner',
}, {
	type: 'null',
}],
	isRequired: true,
},
		partner_supplier: {
	type: 'any-of',
	contains: [{
	type: 'Partner',
}, {
	type: 'null',
}],
	isRequired: true,
},
		claim: {
	type: 'any-of',
	contains: [{
	type: 'Claim',
}, {
	type: 'null',
}],
	isRequired: true,
},
		hire_details: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'number',
}, {
	type: 'string',
}, {
	type: 'null',
}],
},
}, {
	type: 'null',
}],
},
		createdDatetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updatedDatetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		uploads: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
		type: 'Upload',
	},
}, {
	type: 'null',
}],
},
		notes: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
		type: 'Note',
	},
}, {
	type: 'null',
}],
},
		totalScore: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		adjustedLiabilityScore: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		interestedPersons: {
	type: 'array',
	contains: {
		type: 'Interested_Person',
	},
	isRequired: true,
},
		referralAllocations: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
		type: 'Referral_AllocationPublic',
	},
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ReferralUpdate = {
	properties: {
		partnerSourceId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		partnerSupplierId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		authorityId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		claimId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		sourceOrigNote: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		sourceRef: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		daysToHire: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		creditRepair: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Referral_AllocationCreate = {
	properties: {
		partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		referral_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		sentdate: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		hirestatus: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		responsedate: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		hirestartdate: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		hireenddate: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		hire_veh_group_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		allocation_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		pending_reason: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		rejection_reason: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		supplier_ref: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		first_contact_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		FNOL_completed_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		hire_requested_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		repair: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		hire: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		second_tier: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		repair_status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		repair_cancellation_reason: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		repair_bid: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		repair_start_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		repair_end_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		repair_invoice_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		cancelled_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Referral_AllocationPublic = {
	properties: {
		id: {
	type: 'number',
	isRequired: true,
},
		partner_id: {
	type: 'number',
	isRequired: true,
},
		sentdate: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		responsedate: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		allocation_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		hirestatus: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		hirestartdate: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		hireenddate: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		pending_reason: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		rejection_reason: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		supplier_ref: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		first_contact_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		FNOL_completed_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		hire_requested_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		partner: {
	type: 'any-of',
	contains: [{
	type: 'Partner',
}, {
	type: 'null',
}],
},
		repair: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		hire: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		second_tier: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		repair_status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		repair_cancellation_reason: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		repair_bid: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		repair_start_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		repair_end_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		repair_invoice_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Referral_AllocationReallocate = {
	properties: {
		referral_id: {
	type: 'number',
	description: `ID of the referral to reallocate`,
	isRequired: true,
},
		new_partner_id: {
	type: 'number',
	description: `ID of the new partner to allocate to`,
	isRequired: true,
},
		allocation_type: {
	type: 'any-of',
	description: `Type of allocation`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		hirestatus: {
	type: 'any-of',
	description: `Initial hire status`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		hirestartdate: {
	type: 'any-of',
	description: `Hire start date`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		hireenddate: {
	type: 'any-of',
	description: `Hire end date`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		reallocation_note: {
	type: 'any-of',
	description: `Optional note explaining why reallocation is needed`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		send_notifications: {
	type: 'boolean',
	description: `Whether to send notifications and trigger external API calls`,
	default: true,
},
	},
} as const;

export const $Referral_AllocationUpdate = {
	properties: {
		partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		referral_id: {
	type: 'number',
	isRequired: true,
},
		hirestatus: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		hirestartdate: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		hireenddate: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		hire_veh_group_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		pending_reason: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		rejection_reason: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		supplier_ref: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		first_contact_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		FNOL_completed_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		hire_requested_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		repair: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		hire: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		second_tier: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		repair_status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		repair_cancellation_reason: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		repair_bid: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		repair_start_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		repair_end_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		repair_invoice_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		cancelled_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		client_vehicle_drivable: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Referral_AllocationsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'Referral_AllocationPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $ReferralsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'ReferralPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $RegisteredEngineListResponse = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'RegisteredEnginePublic',
	},
	isRequired: true,
},
	},
} as const;

export const $RegisteredEnginePublic = {
	properties: {
		engineKey: {
	type: 'string',
	isRequired: true,
},
		displayName: {
	type: 'string',
	isRequired: true,
},
		description: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $ReportDataClaimContext = {
	description: `Structured claim context consumed directly by the AI agent workflow.

Documented fields are validated and normalized.  Additional partner-specific
keys are accepted (\`\`extra='allow'\`\`), stored in intake \`\`claimContextJson\`\`,
and forwarded to downstream workflows and report templates without a release.`,
	properties: {
		clientFirstname: {
	type: 'any-of',
	description: `Optional client first name.  Included in AI-generated summaries when supplied.`,
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		clientLastname: {
	type: 'any-of',
	description: `Optional client last name.`,
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		callReference: {
	type: 'any-of',
	description: `Partner call or case reference for Call Analysis intake.`,
	contains: [{
	type: 'string',
	maxLength: 128,
}, {
	type: 'null',
}],
},
		callDate: {
	type: 'any-of',
	description: `Date of the call. ISO 8601 format (YYYY-MM-DD).`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		clientVehicleReg: {
	type: 'any-of',
	description: `Optional client vehicle registration number.  Included in AI liability and summary context when supplied.`,
	contains: [{
	type: 'string',
	maxLength: 20,
}, {
	type: 'null',
}],
},
		clientVehicleDrivable: {
	type: 'any-of',
	description: `Whether the client vehicle was drivable after the accident.  Accepts "suitable" or "not-suitable" (and variants such as "driveable", "undriveable"; case-insensitive), or a boolean true/false.  Stored and forwarded to the AI prompt as the canonical string "suitable" or "not suitable".`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		accidentDate: {
	type: 'any-of',
	description: `Date of accident.  ISO 8601 format (YYYY-MM-DD).`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		accidentCircs: {
	type: 'any-of',
	description: `Free-text accident circumstances.  Used directly by AI agents for liability and summary assessment.  Provide as much detail as available.`,
	contains: [{
	type: 'string',
	maxLength: 5000,
}, {
	type: 'null',
}],
},
		claimRoute: {
	type: 'any-of',
	description: `Optional intake routing label provided by the partner. Stored in intake claimContextJson and forwarded to downstream workflows.`,
	contains: [{
	type: 'string',
	maxLength: 128,
}, {
	type: 'null',
}],
},
		handler: {
	type: 'any-of',
	description: `Optional claim handler or case owner name from the partner system. Stored in intake claimContextJson and forwarded to downstream workflows.`,
	contains: [{
	type: 'string',
	maxLength: 128,
}, {
	type: 'null',
}],
},
		daysToHire: {
	type: 'any-of',
	description: `Number of days from accident date to hire start.  Included in AI summary context.`,
	contains: [{
	type: 'number',
	minimum: 0,
}, {
	type: 'null',
}],
},
		hireStatus: {
	type: 'any-of',
	description: `Current hire status.  Used by AI to assess the hire lifecycle.  Valid values: "Pending", "Booked In", "On-Hire", "Off-Hire", "Unpaid", "Paid", "Cancelled".`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		hireStartDate: {
	type: 'any-of',
	description: `Hire start date.  ISO 8601 format (YYYY-MM-DD).  Expected when hireStatus is "On-Hire" or later.`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		hireEndDate: {
	type: 'any-of',
	description: `Hire end date.  ISO 8601 format (YYYY-MM-DD).  Expected when hireStatus is "Off-Hire", "Unpaid", or "Paid".`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ReportDataNoteItem = {
	description: `A single note to attach to the projected referral for AI analysis.`,
	properties: {
		note: {
	type: 'string',
	description: `Note text content.  Attached to the projected referral and included verbatim in the AI context.`,
	isRequired: true,
	maxLength: 10000,
},
		noteDate: {
	type: 'any-of',
	description: `Date/time the note relates to (if different from submission date).  ISO 8601 format (YYYY-MM-DD or full datetime).`,
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ReportTemplateCreate = {
	description: `Model for creating a report template.`,
	properties: {
		name: {
	type: 'string',
	description: `Display name for the template (e.g. "Standard Matt Audit")`,
	isRequired: true,
	maxLength: 200,
},
		description: {
	type: 'any-of',
	description: `What this template is used for`,
	contains: [{
	type: 'string',
	maxLength: 2000,
}, {
	type: 'null',
}],
},
		subjectTemplate: {
	type: 'any-of',
	description: `Jinja2 subject line template, e.g. "Audit Report - {{ system.report_date }}"`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emailHtml: {
	type: 'any-of',
	description: `Jinja2 HTML for the per-urgent-claim card (batch) or full body (legacy)`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emailIntroHtml: {
	type: 'any-of',
	description: `Jinja2 HTML intro (batch context); empty uses default Hi + metrics table`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emailFooterHtml: {
	type: 'any-of',
	description: `Jinja2 HTML footer (batch context); empty uses default sign-off`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		pdfHtml: {
	type: 'any-of',
	description: `Full Jinja2 HTML template rendered to PDF via WeasyPrint`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		csvFields: {
	type: 'any-of',
	description: `Ordered list of {path, label} objects for CSV column definitions`,
	contains: [{
	type: 'array',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		xlsxFields: {
	type: 'any-of',
	description: `Ordered list of {path, label} objects for Excel column definitions`,
	contains: [{
	type: 'array',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		channelsEnabled: {
	type: 'any-of',
	description: `Dict of enabled output channels e.g. {"email": true, "csv": false, "pdf": true, "xlsx": false}`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		mergeBotNames: {
	type: 'any-of',
	description: `Informational: which bot_name values this template is designed for`,
	contains: [{
	type: 'array',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		isActive: {
	type: 'boolean',
	description: `Whether this template is available for use`,
	default: true,
},
	},
} as const;

export const $ReportTemplatePublic = {
	description: `Public model for a report template.`,
	properties: {
		name: {
	type: 'string',
	description: `Display name for the template (e.g. "Standard Matt Audit")`,
	isRequired: true,
	maxLength: 200,
},
		description: {
	type: 'any-of',
	description: `What this template is used for`,
	contains: [{
	type: 'string',
	maxLength: 2000,
}, {
	type: 'null',
}],
},
		subjectTemplate: {
	type: 'any-of',
	description: `Jinja2 subject line template, e.g. "Audit Report - {{ system.report_date }}"`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emailHtml: {
	type: 'any-of',
	description: `Jinja2 HTML for the per-urgent-claim card (batch) or full body (legacy)`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emailIntroHtml: {
	type: 'any-of',
	description: `Jinja2 HTML intro (batch context); empty uses default Hi + metrics table`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emailFooterHtml: {
	type: 'any-of',
	description: `Jinja2 HTML footer (batch context); empty uses default sign-off`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		pdfHtml: {
	type: 'any-of',
	description: `Full Jinja2 HTML template rendered to PDF via WeasyPrint`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		csvFields: {
	type: 'any-of',
	description: `Ordered list of {path, label} objects for CSV column definitions`,
	contains: [{
	type: 'array',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		xlsxFields: {
	type: 'any-of',
	description: `Ordered list of {path, label} objects for Excel column definitions`,
	contains: [{
	type: 'array',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		channelsEnabled: {
	type: 'any-of',
	description: `Dict of enabled output channels e.g. {"email": true, "csv": false, "pdf": true, "xlsx": false}`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		mergeBotNames: {
	type: 'any-of',
	description: `Informational: which bot_name values this template is designed for`,
	contains: [{
	type: 'array',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		isActive: {
	type: 'boolean',
	description: `Whether this template is available for use`,
	default: true,
},
		id: {
	type: 'number',
	isRequired: true,
},
		createdDatetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ReportTemplateUpdate = {
	description: `Model for updating a report template (all fields optional).`,
	properties: {
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 200,
}, {
	type: 'null',
}],
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		subjectTemplate: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emailHtml: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emailIntroHtml: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emailFooterHtml: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		pdfHtml: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		csvFields: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		xlsxFields: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		channelsEnabled: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		mergeBotNames: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		isActive: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ReportTemplatesPublic = {
	description: `Public model for a list of report templates.`,
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'ReportTemplatePublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $RequestCreate = {
	properties: {
		partner_source_id: {
	type: 'number',
	description: `ID of the source partner`,
	isRequired: true,
},
		type: {
	type: 'any-of',
	description: `Type of the request`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		daystohire: {
	type: 'any-of',
	description: `Number of days the vehicle is hired for`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		creditrepair: {
	type: 'any-of',
	description: `Credit repair status`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		authority_id: {
	type: 'any-of',
	description: `ID of the authority`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		client_firstname: {
	type: 'string',
	description: `Client's first name`,
	isRequired: true,
},
		client_lastname: {
	type: 'string',
	description: `Client's last name`,
	isRequired: true,
},
		client_address_1: {
	type: 'any-of',
	description: `First line of client's address`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_address_town: {
	type: 'any-of',
	description: `Client's town`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_address_postcode: {
	type: 'any-of',
	description: `Client's postcode`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_vehicle_reg: {
	type: 'any-of',
	description: `Client's vehicle registration`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_insurer: {
	type: 'any-of',
	description: `Client's insurance company`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_insurer_policyno: {
	type: 'any-of',
	description: `Client's insurance policy number`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_phone: {
	type: 'any-of',
	description: `Client's phone number`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_mobile: {
	type: 'any-of',
	description: `Client's mobile number`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_email: {
	type: 'any-of',
	description: `Client's email address`,
	contains: [{
	type: 'string',
	format: 'email',
}, {
	type: 'null',
}],
},
		plate_type: {
	type: 'any-of',
	description: `License plate type`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		driver_firstname: {
	type: 'any-of',
	description: `Driver First name`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		driver_lastname: {
	type: 'any-of',
	description: `Driver Last name`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		driver_address: {
	type: 'any-of',
	description: `Driver Address`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		driver_postcode: {
	type: 'any-of',
	description: `Driver Postcode`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		driver_phone: {
	type: 'any-of',
	description: `Driver Phone`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		driver_mobile: {
	type: 'any-of',
	description: `Driver Mobile`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		driver_email: {
	type: 'any-of',
	description: `Driver Email`,
	contains: [{
	type: 'string',
	format: 'email',
	maxLength: 254,
}, {
	type: 'null',
}],
},
		driver_dob: {
	type: 'any-of',
	description: `Driver Date of Birth`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		driver_occupation: {
	type: 'any-of',
	description: `Driver Occupation`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		accident_date: {
	type: 'any-of',
	description: `Date of the accident`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		accident_time: {
	type: 'any-of',
	description: `Time of the accident`,
	contains: [{
	type: 'string',
	format: 'time',
}, {
	type: 'null',
}],
},
		accident_location: {
	type: 'any-of',
	description: `Location where the accident occurred`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		accident_circs: {
	type: 'any-of',
	description: `Circumstances of the accident`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_firstname: {
	type: 'any-of',
	description: `Third party's first name`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_lastname: {
	type: 'any-of',
	description: `Third party's last name`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_1: {
	type: 'any-of',
	description: `First line of third party's address`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_town: {
	type: 'any-of',
	description: `Third party's town`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_address_postcode: {
	type: 'any-of',
	description: `Third party's postcode`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_vehicle_reg: {
	type: 'any-of',
	description: `Third party's vehicle registration`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_insurer: {
	type: 'any-of',
	description: `Third party's insurance company`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_insurer_polcyno: {
	type: 'any-of',
	description: `Third party's insurance policy number`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_phone: {
	type: 'any-of',
	description: `Third party's phone number`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		tp_mobile: {
	type: 'any-of',
	description: `Third party's mobile number`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		circs_grade_id: {
	type: 'any-of',
	description: `ID of the circumstances grade`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		veh_group_id: {
	type: 'any-of',
	description: `ID of the vehicle group`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		created_datetime: {
	type: 'any-of',
	description: `Date and time of creation`,
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		allocation_type: {
	type: 'any-of',
	description: `Type of allocation`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		hirestartdate: {
	type: 'any-of',
	description: `Date when hire starts`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		hireenddate: {
	type: 'any-of',
	description: `Date when hire ends`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		hirestatus: {
	type: 'any-of',
	description: `Status of the hire`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		claimscore: {
	type: 'any-of',
	description: `Score of the claim`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		captchaToken: {
	type: 'any-of',
	description: `CAPTCHA verification token`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		useCaptcha: {
	type: 'boolean',
	description: `Whether to use CAPTCHA verification`,
	default: false,
},
		sourceorignote: {
	type: 'any-of',
	description: `Notes about the source or origin`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		source_ref: {
	type: 'any-of',
	description: `Reference from the source`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		pending_reason: {
	type: 'any-of',
	description: `Reason for pending status`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		rejection_reason: {
	type: 'any-of',
	description: `Reason for rejection`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		interested_persons: {
	type: 'any-of',
	description: `List of interested persons related to the request`,
	contains: [{
	type: 'array',
	contains: {
		type: 'Interested_PersonBase',
	},
}, {
	type: 'null',
}],
},
		client_dob: {
	type: 'any-of',
	description: `Client's date of birth`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		client_occupation: {
	type: 'any-of',
	description: `Client's occupation`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		purpose_of_journey: {
	type: 'any-of',
	description: `Purpose of journey`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		pre_existing_damage: {
	type: 'any-of',
	description: `Pre-existing damage`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_damage_description: {
	type: 'any-of',
	description: `Description of client's damage`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		no_of_passengers_clients: {
	type: 'any-of',
	description: `Number of passengers Clients`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		client_speed: {
	type: 'any-of',
	description: `Client's speed`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		any_witnesses: {
	type: 'any-of',
	description: `Were there any witnesses`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		weather_conditions: {
	type: 'any-of',
	description: `Weather conditions`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		source_liability: {
	type: 'any-of',
	description: `Source of liability`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emergency_service_attend: {
	type: 'any-of',
	description: `Emergency service attended`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		police_attended: {
	type: 'any-of',
	description: `Did police attend`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		fire_brigade_attended: {
	type: 'any-of',
	description: `Did fire brigade attend`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		ambulance_attended: {
	type: 'any-of',
	description: `Did ambulance attend`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		police_station_name: {
	type: 'any-of',
	description: `Name of Police station`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		police_officer_name: {
	type: 'any-of',
	description: `Name of Police officer`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		police_reference: {
	type: 'any-of',
	description: `Police Reference`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		policy_cover: {
	type: 'any-of',
	description: `Policy Cover`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		policy_excess: {
	type: 'any-of',
	description: `Policy Excess`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		policy_start_date: {
	type: 'any-of',
	description: `Policy Start Date`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		policy_expiry_date: {
	type: 'any-of',
	description: `Policy Expires Date`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		vat_registered: {
	type: 'any-of',
	description: `VAT Registered`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		policy_vehicle_use: {
	type: 'any-of',
	description: `Policy vehicle use`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		client_vehicle_drivable: {
	type: 'any-of',
	description: `Client Vehicle Drivable`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		client_vehicle_secure: {
	type: 'any-of',
	description: `Client Vehicle Secure`,
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		client_vehicle_location: {
	type: 'any-of',
	description: `Client Vehicle Location`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		is_aca_basic: {
	type: 'boolean',
	description: `Flag to mark ACA Basic variant`,
	default: false,
},
		is_aca_import: {
	type: 'boolean',
	description: `Flag for ACA email imports - assign and send warm-transfer supplier email (no API)`,
	default: false,
},
	},
} as const;

export const $RequestLogPublic = {
	properties: {
		method: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 10,
}, {
	type: 'null',
}],
	isRequired: true,
},
		path: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
	isRequired: true,
},
		query_params: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		headers: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		response_status: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		user_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		api_key: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
	isRequired: true,
},
		ip_address: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		status_code: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		request_body: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'array',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		response_body: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'array',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		path_params: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		process_time: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		billing_status: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 20,
}, {
	type: 'null',
}],
},
		normalized_endpoint: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
	isRequired: true,
},
		rate_limited: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		duration_ms: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		identifier_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 20,
}, {
	type: 'null',
}],
	isRequired: true,
},
		rate_limit_remaining: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		endpoint: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
	isRequired: true,
},
		user_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 50,
}, {
	type: 'null',
}],
	isRequired: true,
},
		id: {
	type: 'number',
	isRequired: true,
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updated_datetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $RequestLogsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'RequestLogPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $Role = {
	properties: {
		createdDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		role: {
	type: 'string',
	isRequired: true,
},
		role_description: {
	type: 'string',
	isRequired: true,
},
		id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $RoleCreate = {
	properties: {
		role: {
	type: 'string',
	isRequired: true,
},
		role_description: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $RolePublic = {
	properties: {
		role: {
	type: 'string',
	isRequired: true,
},
		role_description: {
	type: 'string',
	isRequired: true,
},
		id: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $RoleUpdate = {
	properties: {
		role: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		role_description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Role_AllocationCreate = {
	properties: {
		user_id: {
	type: 'number',
	default: 0,
},
		role_id: {
	type: 'number',
	default: 0,
},
	},
} as const;

export const $Role_AllocationPublic = {
	properties: {
		user_id: {
	type: 'number',
	default: 0,
},
		role_id: {
	type: 'number',
	default: 0,
},
		id: {
	type: 'number',
	isRequired: true,
},
		user: {
	type: 'User',
	isRequired: true,
},
		role: {
	type: 'Role',
	isRequired: true,
},
	},
} as const;

export const $Role_AllocationUpdate = {
	properties: {
		user_id: {
	type: 'number',
	default: 0,
},
		role_id: {
	type: 'number',
	default: 0,
},
	},
} as const;

export const $Role_AllocationsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'Role_AllocationPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $Role_PermissionCreate = {
	properties: {
		role_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		endpoint: {
	type: 'string',
	isRequired: true,
},
		operation: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $Role_PermissionPublic = {
	properties: {
		role_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		endpoint: {
	type: 'string',
	isRequired: true,
},
		operation: {
	type: 'string',
	isRequired: true,
},
		id: {
	type: 'number',
	isRequired: true,
},
		role: {
	type: 'Role',
	isRequired: true,
},
	},
} as const;

export const $Role_PermissionUpdate = {
	properties: {
		role_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		endpoint: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		operation: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Role_PermissionsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'Role_PermissionPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $RolesPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'RolePublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $RunInspectorResponse = {
	properties: {
		referral_id: {
	type: 'number',
	isRequired: true,
},
		agent_runs: {
	type: 'array',
	contains: {
		type: 'AgentRunPublic',
	},
	isRequired: true,
},
		claim_summaries: {
	type: 'array',
	contains: {
		type: 'ClaimSummaryDetailPublic',
	},
	isRequired: true,
},
		workflow: {
	type: 'any-of',
	contains: [{
	type: 'app__api__routes__run_inspector__WorkflowDefinitionPublic',
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;

export const $SecurityTestResultCreate = {
	description: `Model for creating new security test results.`,
	properties: {
		testSuiteName: {
	type: 'string',
	description: `Test suite name (authentication, authorization, etc.)`,
	isRequired: true,
	maxLength: 100,
},
		testName: {
	type: 'string',
	description: `Individual test name`,
	isRequired: true,
	maxLength: 255,
},
		testGroup: {
	type: 'any-of',
	description: `Test group for organizing related tests`,
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		status: {
	type: 'string',
	description: `Test status: passed, failed, skipped, error`,
	isRequired: true,
	maxLength: 20,
},
		environment: {
	type: 'string',
	description: `Execution environment: local, staging, production`,
	isRequired: true,
	maxLength: 50,
},
		durationMs: {
	type: 'number',
	description: `Test execution duration in milliseconds`,
	isRequired: true,
},
		errorMessage: {
	type: 'any-of',
	description: `Error message if test failed`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		stackTrace: {
	type: 'any-of',
	description: `Stack trace for debugging`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		executedAt: {
	type: 'string',
	description: `When the test was executed`,
	format: 'date-time',
},
		executedBy: {
	type: 'string',
	description: `Who executed the test (system or username)`,
	default: 'system',
	maxLength: 100,
},
		metrics: {
	type: 'any-of',
	description: `Additional metrics (coverage %, pass rate, etc.)`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
	},
} as const;

export const $SecurityTestResultPublic = {
	description: `Public model for security test results.`,
	properties: {
		testSuiteName: {
	type: 'string',
	description: `Test suite name (authentication, authorization, etc.)`,
	isRequired: true,
	maxLength: 100,
},
		testName: {
	type: 'string',
	description: `Individual test name`,
	isRequired: true,
	maxLength: 255,
},
		testGroup: {
	type: 'any-of',
	description: `Test group for organizing related tests`,
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		status: {
	type: 'string',
	description: `Test status: passed, failed, skipped, error`,
	isRequired: true,
	maxLength: 20,
},
		environment: {
	type: 'string',
	description: `Execution environment: local, staging, production`,
	isRequired: true,
	maxLength: 50,
},
		durationMs: {
	type: 'number',
	description: `Test execution duration in milliseconds`,
	isRequired: true,
},
		errorMessage: {
	type: 'any-of',
	description: `Error message if test failed`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		stackTrace: {
	type: 'any-of',
	description: `Stack trace for debugging`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		executedAt: {
	type: 'string',
	description: `When the test was executed`,
	format: 'date-time',
},
		executedBy: {
	type: 'string',
	description: `Who executed the test (system or username)`,
	default: 'system',
	maxLength: 100,
},
		metrics: {
	type: 'any-of',
	description: `Additional metrics (coverage %, pass rate, etc.)`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		createdAt: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updatedAt: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
	},
} as const;

export const $SecurityTestResultsPublic = {
	description: `Public model for list of security test results.`,
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'SecurityTestResultPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $ServiceAccountCreateRequest = {
	properties: {
		email: {
	type: 'string',
	isRequired: true,
},
		fullName: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		serviceAccountName: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		brandAccess: {
	type: 'string',
	default: 'wysehub',
},
		partnerId: {
	type: 'number',
	isRequired: true,
},
		roleIds: {
	type: 'array',
	contains: {
	type: 'number',
},
},
	},
} as const;

export const $Source_RateCreate = {
	properties: {
		veh_group_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		allocation_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		rate: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		source_partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		tier: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		start_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		end_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		vehicle_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Source_RatePublic = {
	properties: {
		veh_group_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		allocation_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		rate: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		source_partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		tier: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		start_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		end_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
		source_partner: {
	type: 'any-of',
	contains: [{
	type: 'Partner',
}, {
	type: 'null',
}],
},
		veh_group: {
	type: 'any-of',
	contains: [{
	type: 'Veh_Group',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Source_RateUpdate = {
	properties: {
		veh_group_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		allocation_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		rate: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		source_partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		tier: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		start_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		end_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Source_RatesPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'Source_RatePublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $SummaryFeedbackBody = {
	description: `Request body for in-app summary feedback submission.`,
	properties: {
		rating: {
	type: 'string',
	isRequired: true,
},
		comment: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		reason_code: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		task_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Supplier_RateCreate = {
	properties: {
		authority_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		plate_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		veh_group_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		circs_grade_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		rate: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		hire_length: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		supplier_partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		start_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		end_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		source_partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		rate_override: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		vehicle_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Supplier_RatePublic = {
	properties: {
		authority_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		plate_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		veh_group_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		circs_grade_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		rate: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		hire_length: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		supplier_partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		start_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		end_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		source_partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		rate_override: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
		supplier_partner: {
	type: 'any-of',
	contains: [{
	type: 'Partner',
}, {
	type: 'null',
}],
	isRequired: true,
},
		source_partner: {
	type: 'any-of',
	contains: [{
	type: 'Partner',
}, {
	type: 'null',
}],
	isRequired: true,
},
		veh_group: {
	type: 'any-of',
	contains: [{
	type: 'Veh_Group',
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;

export const $Supplier_RateUpdate = {
	properties: {
		authority_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		plate_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		veh_group_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		circs_grade_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		rate: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		hire_length: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		supplier_partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		start_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		end_date: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		source_partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		rate_override: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		vehicle_type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Supplier_RatesPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'Supplier_RatePublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $SwitchCompanyRequest = {
	properties: {
		tenant_id: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $TaskScheduleConfigCreate = {
	description: `Model for creating task schedule configuration.

SECURITY FIX (INJ-DOS-001): Added payload size limits to prevent DOS attacks.`,
	properties: {
		taskId: {
	type: 'string',
	description: `Unique identifier for the task (e.g., "workflow_scheduled_audit")`,
	isRequired: true,
	maxLength: 100,
},
		taskName: {
	type: 'string',
	description: `Display name for the task`,
	isRequired: true,
	maxLength: 200,
},
		description: {
	type: 'any-of',
	description: `What the task does`,
	contains: [{
	type: 'string',
	maxLength: 2000,
}, {
	type: 'null',
}],
},
		enabled: {
	type: 'boolean',
	description: `Whether the task is currently active`,
	default: true,
},
		status: {
	type: 'string',
	description: `Schedule status: active, disabled, deleted`,
	default: 'active',
	maxLength: 20,
},
		scheduleType: {
	type: 'string',
	description: `Schedule type: "cron", "interval", or "time"`,
	isRequired: true,
	maxLength: 20,
},
		scheduleValue: {
	type: 'string',
	description: `JSON schedule config: {"hour": 15, "minute": 0} or {"seconds": 300} or "0 15 * * *"`,
	isRequired: true,
},
		queueName: {
	type: 'string',
	description: `Celery queue to route the task to`,
	default: 'default',
	maxLength: 50,
},
		emailRecipients: {
	type: 'any-of',
	description: `JSON array of email addresses`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		filterCriteria: {
	type: 'any-of',
	description: `JSON object with task-specific filter parameters`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		outputLayoutProfile: {
	type: 'any-of',
	description: `JSON blob for output channel layout configuration (legacy)`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		reportTemplateId: {
	type: 'any-of',
	description: `FK to report_template — the shared template to use for output`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		templateOverrides: {
	type: 'any-of',
	description: `Per-schedule overrides for subject_template, email_html, or pdf_html`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		mergeBotStepId: {
	type: 'any-of',
	description: `Workflow step ID of the merge bot (defaults to Sally scan when null)`,
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		batchRankingEnabled: {
	type: 'boolean',
	description: `When true, run batch urgency rank agent after workflow batch completes (before report CSV/PDF/email).`,
	default: false,
},
		postBatchAgentKey: {
	type: 'any-of',
	description: `Optional ai_prompt_configs.agent_key to run as a post-batch processor after the workflow batch completes (before report output). When set, this supersedes the legacy batch_ranking_enabled toggle.`,
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		lastRunDatetime: {
	type: 'any-of',
	description: `When the task last executed`,
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		nextRunDatetime: {
	type: 'any-of',
	description: `When the task is scheduled to run next`,
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		executionCount: {
	type: 'number',
	description: `Total number of executions`,
	default: 0,
},
		maxExecutionCount: {
	type: 'any-of',
	description: `Disable the schedule after this many successful executions`,
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		failureCount: {
	type: 'number',
	description: `Total number of failed executions`,
	default: 0,
},
	},
} as const;

export const $TaskScheduleConfigPublic = {
	description: `Public model for task schedule configuration.`,
	properties: {
		taskId: {
	type: 'string',
	description: `Unique identifier for the task (e.g., "workflow_scheduled_audit")`,
	isRequired: true,
	maxLength: 100,
},
		taskName: {
	type: 'string',
	description: `Display name for the task`,
	isRequired: true,
	maxLength: 200,
},
		description: {
	type: 'any-of',
	description: `What the task does`,
	contains: [{
	type: 'string',
	maxLength: 2000,
}, {
	type: 'null',
}],
},
		enabled: {
	type: 'boolean',
	description: `Whether the task is currently active`,
	default: true,
},
		status: {
	type: 'string',
	description: `Schedule status: active, disabled, deleted`,
	default: 'active',
	maxLength: 20,
},
		scheduleType: {
	type: 'string',
	description: `Schedule type: "cron", "interval", or "time"`,
	isRequired: true,
	maxLength: 20,
},
		scheduleValue: {
	type: 'string',
	description: `JSON schedule config: {"hour": 15, "minute": 0} or {"seconds": 300} or "0 15 * * *"`,
	isRequired: true,
},
		queueName: {
	type: 'string',
	description: `Celery queue to route the task to`,
	default: 'default',
	maxLength: 50,
},
		emailRecipients: {
	type: 'any-of',
	description: `JSON array of email addresses`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		filterCriteria: {
	type: 'any-of',
	description: `JSON object with task-specific filter parameters`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		outputLayoutProfile: {
	type: 'any-of',
	description: `JSON blob for output channel layout configuration (legacy)`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		reportTemplateId: {
	type: 'any-of',
	description: `FK to report_template — the shared template to use for output`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		templateOverrides: {
	type: 'any-of',
	description: `Per-schedule overrides for subject_template, email_html, or pdf_html`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		mergeBotStepId: {
	type: 'any-of',
	description: `Workflow step ID of the merge bot (defaults to Sally scan when null)`,
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		batchRankingEnabled: {
	type: 'boolean',
	description: `When true, run batch urgency rank agent after workflow batch completes (before report CSV/PDF/email).`,
	default: false,
},
		postBatchAgentKey: {
	type: 'any-of',
	description: `Optional ai_prompt_configs.agent_key to run as a post-batch processor after the workflow batch completes (before report output). When set, this supersedes the legacy batch_ranking_enabled toggle.`,
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		lastRunDatetime: {
	type: 'any-of',
	description: `When the task last executed`,
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		nextRunDatetime: {
	type: 'any-of',
	description: `When the task is scheduled to run next`,
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		executionCount: {
	type: 'number',
	description: `Total number of executions`,
	default: 0,
},
		maxExecutionCount: {
	type: 'any-of',
	description: `Disable the schedule after this many successful executions`,
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		failureCount: {
	type: 'number',
	description: `Total number of failed executions`,
	default: 0,
},
		recentFailureCount: {
	type: 'number',
	description: `Failed executions in the rolling health window (7 days)`,
	default: 0,
},
		id: {
	type: 'number',
	isRequired: true,
},
		createdDatetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $TaskScheduleConfigUpdate = {
	description: `Model for updating task schedule configuration.

SECURITY FIX (INJ-DOS-001): Added payload size limits to prevent DOS attacks.`,
	properties: {
		taskName: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 200,
}, {
	type: 'null',
}],
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 2000,
}, {
	type: 'null',
}],
},
		enabled: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 20,
}, {
	type: 'null',
}],
},
		scheduleType: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 20,
}, {
	type: 'null',
}],
},
		scheduleValue: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		queueName: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 50,
}, {
	type: 'null',
}],
},
		emailRecipients: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		filterCriteria: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		outputLayoutProfile: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		reportTemplateId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		templateOverrides: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		mergeBotStepId: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		batchRankingEnabled: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		postBatchAgentKey: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 100,
}, {
	type: 'null',
}],
},
		lastRunDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		nextRunDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		executionCount: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		maxExecutionCount: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		failureCount: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $TaskScheduleConfigsPublic = {
	description: `Public model for list of task schedule configurations.`,
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'TaskScheduleConfigPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $TaskScheduleExecutionPublic = {
	description: `Public model for task execution history.`,
	properties: {
		taskScheduleId: {
	type: 'number',
	description: `Foreign key to TaskScheduleConfig`,
	isRequired: true,
},
		scheduledTime: {
	type: 'string',
	description: `When the task should have run (UTC)`,
	isRequired: true,
	format: 'date-time',
},
		actualStartTime: {
	type: 'any-of',
	description: `When execution actually started (UTC)`,
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		actualEndTime: {
	type: 'any-of',
	description: `When execution completed (UTC)`,
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		durationSeconds: {
	type: 'any-of',
	description: `Execution duration in seconds`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		status: {
	type: 'string',
	description: `Execution status: pending, running, success, failed, queued_dispatch`,
	isRequired: true,
	maxLength: 20,
},
		errorMessage: {
	type: 'any-of',
	description: `Error message if execution failed`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		rowsProcessed: {
	type: 'any-of',
	description: `Number of records processed (task-specific)`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		batchItemsTotal: {
	type: 'any-of',
	description: `Total batch inference / staging items for this execution`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		batchItemsCompleted: {
	type: 'any-of',
	description: `Batch items completed (provider batch or immediate fallback)`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		batchItemsFallback: {
	type: 'any-of',
	description: `Batch items completed via row-level Celery fallback`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		workflowCallbackPayload: {
	type: 'any-of',
	description: `Serialized process_workflow_audit_results kwargs`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		dispatchReadyAt: {
	type: 'any-of',
	description: `When queued workflow staging should be released for LLM dispatch (UTC)`,
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
		createdDatetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $TaskScheduleExecutionsPublic = {
	description: `Public model for list of task executions.`,
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'TaskScheduleExecutionPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $TestRequest = {
	properties: {
		referral_id: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $UpdatePassword = {
	properties: {
		currentPassword: {
	type: 'string',
	isRequired: true,
	maxLength: 40,
	minLength: 8,
},
		newPassword: {
	type: 'string',
	isRequired: true,
	maxLength: 40,
	minLength: 8,
},
	},
} as const;

export const $Upload = {
	properties: {
		createdDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		referral_id: {
	type: 'number',
},
		file_name: {
	type: 'string',
	isRequired: true,
	maxLength: 255,
},
		file_path: {
	type: 'string',
	isRequired: true,
	maxLength: 255,
},
		created_by: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $User = {
	properties: {
		createdDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		email: {
	type: 'string',
	isRequired: true,
	format: 'email',
	maxLength: 254,
},
		isActive: {
	type: 'boolean',
	default: true,
},
		fullName: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		effectivePartnerType: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		brandAccess: {
	type: 'string',
	description: `wysehub | aiclaims | both`,
	default: 'wysehub',
	maxLength: 20,
},
		accountType: {
	type: 'string',
	description: `human | service`,
	default: 'human',
	maxLength: 20,
},
		canPortalLogin: {
	type: 'boolean',
	default: true,
},
		serviceAccountName: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		isSuperuser: {
	type: 'boolean',
	default: false,
},
		id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		hashed_password: {
	type: 'string',
	isRequired: true,
},
		requiresOtp: {
	type: 'boolean',
	default: false,
},
		locked: {
	type: 'boolean',
	default: false,
},
		managedByUserId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $UserCreate = {
	properties: {
		email: {
	type: 'string',
	isRequired: true,
	format: 'email',
	maxLength: 254,
},
		isActive: {
	type: 'boolean',
	default: true,
},
		fullName: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		effectivePartnerType: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		brandAccess: {
	type: 'string',
	description: `wysehub | aiclaims | both`,
	default: 'wysehub',
	maxLength: 20,
},
		accountType: {
	type: 'string',
	description: `human | service`,
	default: 'human',
	maxLength: 20,
},
		canPortalLogin: {
	type: 'boolean',
	default: true,
},
		serviceAccountName: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		password: {
	type: 'string',
	isRequired: true,
	maxLength: 40,
	minLength: 8,
},
		requiresOtp: {
	type: 'boolean',
	default: false,
},
	},
} as const;

export const $UserPublic = {
	properties: {
		email: {
	type: 'string',
	isRequired: true,
},
		isActive: {
	type: 'boolean',
	default: true,
},
		fullName: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		effectivePartnerType: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		brandAccess: {
	type: 'string',
	description: `wysehub | aiclaims | both`,
	default: 'wysehub',
	maxLength: 20,
},
		accountType: {
	type: 'string',
	description: `human | service`,
	default: 'human',
	maxLength: 20,
},
		canPortalLogin: {
	type: 'boolean',
	default: true,
},
		serviceAccountName: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
		rolenames: {
	type: 'array',
	contains: {
	type: 'string',
},
	isRequired: true,
},
		partnerTypes: {
	type: 'array',
	contains: {
	type: 'string',
},
	isRequired: true,
},
		activeBrand: {
	type: 'any-of',
	description: `Resolved wysehub | aiclaims for this request (not persisted)`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $UserPublicBasic = {
	properties: {
		email: {
	type: 'string',
	isRequired: true,
},
		isActive: {
	type: 'boolean',
	default: true,
},
		fullName: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		effectivePartnerType: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		brandAccess: {
	type: 'string',
	description: `wysehub | aiclaims | both`,
	default: 'wysehub',
	maxLength: 20,
},
		accountType: {
	type: 'string',
	description: `human | service`,
	default: 'human',
	maxLength: 20,
},
		canPortalLogin: {
	type: 'boolean',
	default: true,
},
		serviceAccountName: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $UserRegister = {
	properties: {
		email: {
	type: 'string',
	isRequired: true,
	format: 'email',
	maxLength: 254,
},
		password: {
	type: 'string',
	isRequired: true,
	maxLength: 40,
	minLength: 8,
},
		fullName: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
	},
} as const;

export const $UserUpdate = {
	properties: {
		email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'email',
	maxLength: 254,
}, {
	type: 'null',
}],
},
		isActive: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		fullName: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		effectivePartnerType: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		brandAccess: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 20,
}, {
	type: 'null',
}],
},
		password: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 40,
	minLength: 8,
}, {
	type: 'null',
}],
},
	},
} as const;

export const $UserUpdateMe = {
	properties: {
		fullName: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		email: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'email',
	maxLength: 254,
}, {
	type: 'null',
}],
},
		effectivePartnerType: {
	type: 'any-of',
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
	},
} as const;

export const $User_PartnerCreate = {
	properties: {
		partner_id: {
	type: 'number',
	default: 0,
},
		user_id: {
	type: 'number',
	default: 0,
},
	},
} as const;

export const $User_PartnerPublic = {
	properties: {
		partner_id: {
	type: 'number',
	default: 0,
},
		user_id: {
	type: 'number',
	default: 0,
},
		id: {
	type: 'number',
	isRequired: true,
},
		partner: {
	type: 'Partner',
	isRequired: true,
},
		user: {
	type: 'User',
	isRequired: true,
},
	},
} as const;

export const $User_PartnerUpdate = {
	properties: {
		partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		user_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $User_PartnersPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'User_PartnerPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $UsersPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'UserPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $ValidationError = {
	properties: {
		loc: {
	type: 'array',
	contains: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'number',
}],
},
	isRequired: true,
},
		msg: {
	type: 'string',
	isRequired: true,
},
		type: {
	type: 'string',
	isRequired: true,
},
		input: {
	properties: {
	},
},
		ctx: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
},
	},
} as const;

export const $Veh_Group = {
	properties: {
		createdDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		updatedDatetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		group: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		desc: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Veh_GroupCreate = {
	properties: {
		group: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		desc: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Veh_GroupPublic = {
	properties: {
		group: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		desc: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $Veh_GroupUpdate = {
	properties: {
		group: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		desc: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		type: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Veh_GroupsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'Veh_GroupPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $WorkflowBillingEventPublic = {
	properties: {
		partnerId: {
	type: 'any-of',
	description: `Billing partner. NULL for default/unresolved partner runs.`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		workflowKey: {
	type: 'string',
	description: `e.g. 'matt', 'annie'`,
	isRequired: true,
	maxLength: 100,
},
		referralId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		taskId: {
	type: 'any-of',
	description: `Links to the group of agent_runs for this workflow run.`,
	contains: [{
	type: 'string',
	maxLength: 255,
}, {
	type: 'null',
}],
},
		billingType: {
	type: 'string',
	description: `'workflow_run' for agent runs.`,
	isRequired: true,
	maxLength: 50,
},
		billingPeriod: {
	type: 'string',
	description: `First day of the billing month (YYYY-MM-01).`,
	isRequired: true,
	format: 'date',
},
		status: {
	type: 'string',
	description: `'pending' | 'billed' | 'excluded' | 'capped'`,
	default: 'pending',
	maxLength: 20,
},
		invoiceId: {
	type: 'any-of',
	description: `Set when the event is included on an invoice.`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		startedAt: {
	type: 'string',
	description: `When the workflow run was dispatched.`,
	isRequired: true,
	format: 'date-time',
},
		evaluationMode: {
	type: 'boolean',
	description: `True for test/evaluation runs that should not be billed.`,
	default: false,
},
		id: {
	type: 'number',
	isRequired: true,
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updated_datetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;

export const $WorkflowBillingEventUpdate = {
	properties: {
		status: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		invoiceId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $WorkflowBillingEventsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'WorkflowBillingEventPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $WorkflowBuilderCommitRequest = {
	properties: {
		intent: {
	type: 'string',
	isRequired: true,
	minLength: 1,
},
		workflowKey: {
	type: 'string',
	isRequired: true,
	minLength: 1,
},
		displayName: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		partnerId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		prompt: {
	type: 'WorkflowPromptPayload',
	isRequired: true,
},
		workflow: {
	type: 'WorkflowBuilderWorkflowPayload',
	isRequired: true,
},
		output: {
	type: 'WorkflowBuilderOutputPayload',
	isRequired: true,
},
		schedule: {
	type: 'WorkflowBuilderSchedulePayload',
},
	},
} as const;

export const $WorkflowBuilderCommitResult = {
	properties: {
		promptConfigId: {
	type: 'number',
	isRequired: true,
},
		workflowDefinitionId: {
	type: 'number',
	isRequired: true,
},
		reportTemplateId: {
	type: 'number',
	isRequired: true,
},
		scheduleConfigId: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $WorkflowBuilderOutputPayload = {
	properties: {
		name: {
	type: 'string',
	isRequired: true,
	minLength: 1,
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		subjectTemplate: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emailHtml: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emailIntroHtml: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		emailFooterHtml: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		pdfHtml: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		csvFields: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
},
}, {
	type: 'null',
}],
},
		xlsxFields: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
},
}, {
	type: 'null',
}],
},
		channelsEnabled: {
	type: 'dictionary',
	contains: {
	type: 'boolean',
},
},
		mergeBotNames: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'string',
},
}, {
	type: 'null',
}],
},
	},
} as const;

export const $WorkflowBuilderOutputRequest = {
	properties: {
		intent: {
	type: 'string',
	isRequired: true,
	minLength: 1,
},
		workflowKey: {
	type: 'string',
	isRequired: true,
	minLength: 1,
},
		workflow: {
	type: 'WorkflowBuilderWorkflowPayload',
	isRequired: true,
},
		prompt: {
	type: 'WorkflowPromptPayload',
	isRequired: true,
},
	},
} as const;

export const $WorkflowBuilderPromptRequest = {
	properties: {
		intent: {
	type: 'string',
	isRequired: true,
	minLength: 1,
},
		workflowKey: {
	type: 'string',
	isRequired: true,
	minLength: 1,
},
		displayName: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		model: {
	type: 'string',
	default: 'sonnet46',
},
		variant: {
	type: 'string',
	default: 'default',
},
		maxTokens: {
	type: 'number',
	default: 250,
	maximum: 64000,
	minimum: 50,
},
		temperature: {
	type: 'number',
	default: 0.5,
	maximum: 2,
	minimum: 0,
},
	},
} as const;

export const $WorkflowBuilderSchedulePayload = {
	properties: {
		scheduleType: {
	type: 'string',
	default: 'cron',
},
		scheduleValue: {
	type: 'string',
	default: '"0 8 * * 1"',
},
		emailRecipients: {
	type: 'array',
	contains: {
	type: 'string',
},
},
		maxExecutionCount: {
	type: 'any-of',
	contains: [{
	type: 'number',
	minimum: 1,
}, {
	type: 'null',
}],
},
		enabled: {
	type: 'boolean',
	default: false,
},
	},
} as const;

export const $WorkflowBuilderWorkflowPayload = {
	properties: {
		workflowKey: {
	type: 'string',
	isRequired: true,
	minLength: 1,
},
		displayName: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		definition: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
	isRequired: true,
},
		mergeBotStepId: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $WorkflowBuilderWorkflowRequest = {
	properties: {
		intent: {
	type: 'string',
	isRequired: true,
	minLength: 1,
},
		workflowKey: {
	type: 'string',
	isRequired: true,
	minLength: 1,
},
		displayName: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		includeSally: {
	type: 'boolean',
	default: true,
},
		prompt: {
	type: 'WorkflowPromptPayload',
	isRequired: true,
},
	},
} as const;

export const $WorkflowCardPublic = {
	properties: {
		displayName: {
	type: 'string',
	isRequired: true,
},
		workflowKey: {
	type: 'string',
	isRequired: true,
},
		tenantId: {
	type: 'string',
	isRequired: true,
},
		workflowId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		severity: {
	type: 'Enum',
	enum: ['ok','warn','err',],
	isRequired: true,
},
		statusLine: {
	type: 'string',
	isRequired: true,
},
		lastRunAt: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		runsInPeriod: {
	type: 'number',
	isRequired: true,
},
		inputTokens: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		outputTokens: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		cacheCreationInputTokens: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		cacheReadInputTokens: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		periodCost: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $WorkflowCardsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'WorkflowCardPublic',
	},
	isRequired: true,
},
	},
} as const;

export const $WorkflowListResponse = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'app__api__routes__workflow_definitions__WorkflowDefinitionPublic',
	},
	isRequired: true,
},
	},
} as const;

export const $WorkflowPromptPayload = {
	properties: {
		agentKey: {
	type: 'string',
	isRequired: true,
	minLength: 1,
},
		variant: {
	type: 'string',
	default: 'default',
},
		model: {
	type: 'string',
	default: 'sonnet46',
},
		version: {
	type: 'string',
	default: 'v1',
},
		systemPrompt: {
	type: 'string',
	isRequired: true,
	minLength: 1,
},
		maxTokens: {
	type: 'number',
	default: 250,
	maximum: 64000,
	minimum: 50,
},
		temperature: {
	type: 'number',
	default: 0.5,
	maximum: 2,
	minimum: 0,
},
		outputSchemaJson: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
	},
} as const;

export const $WorkflowRateConfigCreate = {
	properties: {
		partnerId: {
	type: 'number',
	isRequired: true,
},
		workflowKey: {
	type: 'string',
	description: `Workflow identifier (e.g., 'matt', 'annie')`,
	isRequired: true,
	maxLength: 100,
},
		isActive: {
	type: 'boolean',
	default: true,
},
		ratePerRun: {
	type: 'number',
	description: `Cost per workflow run`,
	isRequired: true,
},
		minRunsPerMonth: {
	type: 'any-of',
	description: `Minimum billable runs per month (for tiered pricing)`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		maxRunsPerMonth: {
	type: 'any-of',
	description: `Maximum runs per month before additional rate applies`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		overageRate: {
	type: 'any-of',
	description: `Rate for runs exceeding max_runs_per_month`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		volumeDiscountType: {
	type: 'any-of',
	description: `Type of volume discount ('percentage', 'fixed_price', None for none)`,
	contains: [{
	type: 'string',
	maxLength: 20,
}, {
	type: 'null',
}],
},
		volumeDiscountThreshold: {
	type: 'any-of',
	description: `Number of runs needed to qualify for volume discount`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		volumeDiscountValue: {
	type: 'any-of',
	description: `Discount value (percentage 0-100 or fixed price)`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		effectiveFrom: {
	type: 'any-of',
	description: `Date when this rate becomes effective`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		effectiveTo: {
	type: 'any-of',
	description: `Date when this rate expires (NULL = indefinite)`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $WorkflowRateConfigPublic = {
	properties: {
		partnerId: {
	type: 'number',
	isRequired: true,
},
		workflowKey: {
	type: 'string',
	description: `Workflow identifier (e.g., 'matt', 'annie')`,
	isRequired: true,
	maxLength: 100,
},
		isActive: {
	type: 'boolean',
	default: true,
},
		ratePerRun: {
	type: 'number',
	description: `Cost per workflow run`,
	isRequired: true,
},
		minRunsPerMonth: {
	type: 'any-of',
	description: `Minimum billable runs per month (for tiered pricing)`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		maxRunsPerMonth: {
	type: 'any-of',
	description: `Maximum runs per month before additional rate applies`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		overageRate: {
	type: 'any-of',
	description: `Rate for runs exceeding max_runs_per_month`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		volumeDiscountType: {
	type: 'any-of',
	description: `Type of volume discount ('percentage', 'fixed_price', None for none)`,
	contains: [{
	type: 'string',
	maxLength: 20,
}, {
	type: 'null',
}],
},
		volumeDiscountThreshold: {
	type: 'any-of',
	description: `Number of runs needed to qualify for volume discount`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		volumeDiscountValue: {
	type: 'any-of',
	description: `Discount value (percentage 0-100 or fixed price)`,
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		effectiveFrom: {
	type: 'any-of',
	description: `Date when this rate becomes effective`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		effectiveTo: {
	type: 'any-of',
	description: `Date when this rate expires (NULL = indefinite)`,
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		id: {
	type: 'number',
	isRequired: true,
},
		created_datetime: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		updated_datetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;

export const $WorkflowRateConfigUpdate = {
	properties: {
		isActive: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		ratePerRun: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		minRunsPerMonth: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		maxRunsPerMonth: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		overageRate: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		volumeDiscountType: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		volumeDiscountThreshold: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		volumeDiscountValue: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		effectiveFrom: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
		effectiveTo: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $WorkflowRateConfigsPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'WorkflowRateConfigPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $WorkflowRunDetailPublic = {
	properties: {
		taskId: {
	type: 'string',
	isRequired: true,
},
		grafanaBaseUrl: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		agent_runs: {
	type: 'array',
	contains: {
		type: 'AgentRunPublic',
	},
	isRequired: true,
},
		feedback_requests: {
	type: 'array',
	contains: {
		type: 'FeedbackRequestPublic',
	},
	isRequired: true,
},
		feedback_responses: {
	type: 'array',
	contains: {
		type: 'FeedbackResponsePublic',
	},
	isRequired: true,
},
	},
} as const;

export const $WorkflowRunSummaryPublic = {
	properties: {
		taskId: {
	type: 'string',
	isRequired: true,
},
		lastRunAt: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		stepCount: {
	type: 'number',
	isRequired: true,
},
		referralId: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		primaryAgentName: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		runType: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		traceId: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		feedbackUp: {
	type: 'number',
	isRequired: true,
},
		feedbackDown: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $WorkflowRunsListPublic = {
	properties: {
		data: {
	type: 'array',
	contains: {
		type: 'WorkflowRunSummaryPublic',
	},
	isRequired: true,
},
		count: {
	type: 'number',
	isRequired: true,
},
	},
} as const;

export const $WorkflowSpec = {
	properties: {
		partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		workflow_key: {
	type: 'string',
	isRequired: true,
},
		status: {
	type: 'string',
	default: 'published',
},
	},
} as const;

export const $XeroSeedRequest = {
	properties: {
		refresh_token: {
	type: 'string',
	isRequired: true,
},
		tenant_id: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $app__api__routes__run_inspector__WorkflowDefinitionPublic = {
	properties: {
		id: {
	type: 'number',
	isRequired: true,
},
		partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		workflow_key: {
	type: 'string',
	isRequired: true,
},
		display_name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		version: {
	type: 'number',
	isRequired: true,
},
		definition: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
	isRequired: true,
},
		status: {
	type: 'string',
	isRequired: true,
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;

export const $app__api__routes__workflow_definitions__WorkflowDefinitionPublic = {
	description: `API shape for workflow rows; *definition* is always a JSON object for clients.`,
	properties: {
		id: {
	type: 'number',
	isRequired: true,
},
		partner_id: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		workflow_key: {
	type: 'string',
	isRequired: true,
},
		display_name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		version: {
	type: 'number',
	isRequired: true,
},
		definition: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
},
		status: {
	type: 'string',
	isRequired: true,
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		created_datetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		updated_datetime: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;